export enum TranslationKeys {
  accessonbehalfactivationbox_error_bpnotaccessible = 'accessonbehalfactivationbox_error_bpnotaccessible',
  accessonbehalfactivationbox_error_bpnotfound = 'accessonbehalfactivationbox_error_bpnotfound',
  accessonbehalfactivationbox_error_invalidbpnumber = 'accessonbehalfactivationbox_error_invalidbpnumber',
  accessonbehalfactivationbox_placeholder_enterbpName = 'accessonbehalfactivationbox_placeholder_enterbpName',
  businessPartner_select_bp_number = 'businessPartner_select_bp_number',
  businessPartner_selected_bp = 'businessPartner_selected_bp',
  businessPartner_recently_used = 'businessPartner_recently_used',
  businessPartner_all_bp = 'businessPartner_all_bp',
  businessPartner_placeholder_enterBP = 'businessPartner_placeholder_enterBP',
  change_cookie_settings_btn = 'change_cookie_settings_btn',
  common_back = 'common_back',
  common_closeButton = 'common_closeButton',
  common_dontshowagain = 'common_dontshowagain',
  common_genericerror = 'common_genericerror',
  common_next = 'common_next',
  cookie_declaration = 'cookie_declaration',
  dataprotection_document_language = 'dataprotection_document_language',
  dataprotection_document_name = 'dataprotection_document_name',
  dataprotection_documents = 'dataprotection_documents',
  dataprotection_title = 'dataprotection_title',
  empty = 'empty',
  feedbackForm_cancelButton = 'feedbackForm_cancelButton',
  feedbackForm_label_agriCenter = 'feedbackForm_label_agriCenter',
  feedbackForm_label_description = 'feedbackForm_label_description',
  feedbackForm_noSelection = 'feedbackForm_noSelection',
  feedbackForm_placeholder_description = 'feedbackForm_placeholder_description',
  feedbackForm_submitButton = 'feedbackForm_submitButton',
  feedbackModal_instructions = 'feedbackModal_instructions',
  feedbackModal_subtitle_help = 'feedbackModal_subtitle_help',
  feedbackModal_thanks = 'feedbackModal_thanks',
  feedbackModal_title_thankYou = 'feedbackModal_title_thankYou',
  feedbackModal_title_yourFeedback = 'feedbackModal_title_yourFeedback',
  feedbackSuccessMessage_description = 'feedbackSuccessMessage_description',
  feedbackSuccessMessage_submitted = 'feedbackSuccessMessage_submitted',
  feedbackSuccessMessage_thankYou = 'feedbackSuccessMessage_thankYou',
  feedbackSuccessMessage_title = 'feedbackSuccessMessage_title',
  feedbackModal_error_submission = 'feedbackModal_error_submission',
  feedbackModal_error_generic = 'feedbackModal_error_generic',
  footer_copyright = 'footer_copyright',
  footer_dataProtection = 'footer_dataProtection',
  footer_imprint = 'footer_imprint',
  footer_submitFeedback = 'footer_submitFeedback',
  footer_submitYourFeedbackTitle = 'footer_submitYourFeedbackTitle',
  footer_termsOfService = 'footer_termsOfService',
  imprint_address_line_1 = 'imprint_address_line_1',
  imprint_address_line_2 = 'imprint_address_line_2',
  imprint_address_line_3 = 'imprint_address_line_3',
  imprint_braunschweig = 'imprint_braunschweig',
  imprint_chairman = 'imprint_chairman',
  imprint_chairman_name = 'imprint_chairman_name',
  imprint_company = 'imprint_company',
  imprint_company_headquarters = 'imprint_company_headquarters',
  imprint_company_register = 'imprint_company_register',
  imprint_corporate_communications = 'imprint_corporate_communications',
  imprint_corporate_communications_text = 'imprint_corporate_communications_text',
  imprint_dispute_resolution = 'imprint_dispute_resolution',
  imprint_editorial_office = 'imprint_editorial_office',
  imprint_email = 'imprint_email',
  imprint_executive_board = 'imprint_executive_board',
  imprint_executive_board_chairman = 'imprint_executive_board_chairman',
  imprint_executive_board_member1 = 'imprint_executive_board_member1',
  imprint_executive_board_member2 = 'imprint_executive_board_member2',
  imprint_information_disclaimer = 'imprint_information_disclaimer',
  imprint_kuchenstrasse_9 = 'imprint_kuchenstrasse_9',
  imprint_local_court = 'imprint_local_court',
  imprint_publisher = 'imprint_publisher',
  imprint_telephone = 'imprint_telephone',
  imprint_title = 'imprint_title',
  imprint_vat_number = 'imprint_vat_number',
  infocard_readmore = 'infocard_readmore',
  masterdata_pageHeader = 'masterdata_pageHeader',
  masterdata_masterdata_title = 'masterdata_masterdata_title',
  masterdata_address_title = 'masterdata_address_title',
  masterdata_communication_title = 'masterdata_communication_title',
  masterdata_field_name = 'masterdata_field_name',
  masterdata_field_anrede = 'masterdata_field_anrede',
  masterdata_field_bp_number = 'masterdata_field_bp_number',
  masterdata_field_street = 'masterdata_field_street',
  masterdata_field_zipcode = 'masterdata_field_zipcode',
  masterdata_field_city = 'masterdata_field_city',
  masterdata_field_district = 'masterdata_field_district',
  masterdata_field_regional_office = 'masterdata_field_regional_office',
  masterdata_field_bzp = 'masterdata_field_bzp',
  masterdata_field_distance = 'masterdata_field_distance',
  masterdata_field_phone = 'masterdata_field_phone',
  masterdata_field_email = 'masterdata_field_email',
  masterdata_field_fax = 'masterdata_field_fax',
  my_campaign_pageHeader = 'my_campaign_pageHeader',
  my_campaign_deliveryPlan_button = 'my_campaign_deliveryPlan_button',
  my_contacts_title = 'my_contacts_title',
  my_contracts_title = 'my_contracts_title',
  my_contacts_send_email = 'my_contacts_send_email',
  my_contacts_no_contacts_found = 'my_contacts_no_contacts_found',
  profilesettings_buttons_saveprofile = 'profilesettings_buttons_saveprofile',
  profilesettings_profileheader_accountandlogin = 'profilesettings_profileheader_accountandlogin',
  profilesettings_profileheader_contactinformation = 'profilesettings_profileheader_contactinformation',
  profilesettings_profileheader_cropconnectsettings = 'profilesettings_profileheader_cropconnectsettings',
  sidebar_beetGrowing = 'sidebar_beetGrowing',
  sidebar_data_protection = 'sidebar_data_protection',
  sidebar_feedback = 'sidebar_feedback',
  sidebar_help = 'sidebar_help',
  sidebar_home = 'sidebar_home',
  sidebar_imprint = 'sidebar_imprint',
  sidebar_masterdata = 'sidebar_masterdata',
  sidebar_myCampaign = 'sidebar_myCampaign',
  sidebar_myContracts = 'sidebar_myContracts',
  sidebar_myFieldsYields = 'sidebar_myFieldsYields',
  sidebar_myOrders = 'sidebar_myOrders',
  sidebar_myPayments = 'sidebar_myPayments',
  sidebar_nordzucker = 'sidebar_nordzucker',
  sidebar_terms_and_conditions = 'sidebar_terms_and_conditions',
  sidebar_tools = 'sidebar_tools',
  sidebar_contacts = 'sidebar_contacts',
  sidebar_agripartner_link = 'sidebar_agripartner_link',
  terms_document_language = 'terms_document_language',
  terms_document_name = 'terms_document_name',
  terms_documents = 'terms_documents',
  terms_title = 'terms_title',
  topbarinternalnavigation_navitem_campaigns = 'topbarinternalnavigation_navitem_campaigns',
  topbarinternalnavigation_navitem_contracts = 'topbarinternalnavigation_navitem_contracts',
  topbarinternalnavigation_navitem_finances = 'topbarinternalnavigation_navitem_finances',
  topbarinternalnavigation_navitem_orderedanddeliveredproducts = 'topbarinternalnavigation_navitem_orderedanddeliveredproducts',
  topbarinternalnavigation_navitem_singlebeetdelivery = 'topbarinternalnavigation_navitem_singlebeetdelivery',
  usermenu_item_logout = 'usermenu_item_logout',
  usermenu_item_username_placeholder = 'usermenu_item_username_placeholder',
  usermenu_item_profile = 'usermenu_item_profile',
  mobileHeader_appTitle = 'mobileHeader_appTitle',
  mobileHeader_subtitle = 'mobileHeader_subtitle',
  mobileHeader_bpNumber = 'mobileHeader_bpNumber',
  homeNews_welcome_text = 'homeNews_welcome_text',
  homeNews_more_news = 'homeNews_more_news',
  homeNews_read_more = 'homeNews_read_more',
  common_back_to_overview = 'common_back_to_overview',
  common_report_not_released = 'common_report_not_released',
  orderedAndDeliveredProducts_report_title = 'orderedAndDeliveredProducts_report_title',
  fieldsAndYields_report_title = 'fieldsAndYields_report_title',
  finances_report_title = 'finances_report_title',
  campaigns_report_title = 'campaigns_report_title',
  userSettings_pageHeader = 'userSettings_pageHeader',
  userSettings_label_userName = 'userSettings_label_userName',
  userSettings_label_email = 'userSettings_label_email',
  userSettings_label_password = 'userSettings_label_password',
  userSettings_subtitle_contactInformation = 'userSettings_subtitle_contactInformation',
  userSettings_subtitle_accountSettings = 'userSettings_subtitle_accountSettings',
  userSettings_label_language = 'userSettings_label_language',
  lieferanspruch_widget_title = 'lieferanspruch_widget_title',
  lieferanspruch_widget_subtitle = 'lieferanspruch_widget_subtitle',
  lieferanspruch_widget_total_entitlement = 'lieferanspruch_widget_total_entitlement',
  lieferanspruch_widget_contracted_amount = 'lieferanspruch_widget_contracted_amount',
  lieferanspruch_widget_available_amount = 'lieferanspruch_widget_available_amount',
  lieferanspruch_widget_more_info = 'lieferanspruch_widget_more_info',
  lieferanspruch_modal_title = 'lieferanspruch_modal_title',
  lieferanspruch_modal_total_entitlement = 'lieferanspruch_modal_total_entitlement',
  lieferanspruch_modal_contracted_amount = 'lieferanspruch_modal_contracted_amount',
  lieferanspruch_modal_available_amount = 'lieferanspruch_modal_available_amount',
  lieferanspruch_modal_subtitle_entitlement_info = 'lieferanspruch_modal_subtitle_entitlement_info',
  lieferanspruch_modal_text_entitlement_info_part1 = 'lieferanspruch_modal_text_entitlement_info_part1',
  lieferanspruch_modal_text_entitlement_info_part2 = 'lieferanspruch_modal_text_entitlement_info_part2',
  lieferanspruch_modal_subtitle_factors = 'lieferanspruch_modal_subtitle_factors',
  lieferanspruch_modal_factor_nz_holding = 'lieferanspruch_modal_factor_nz_holding',
  lieferanspruch_modal_factor_union = 'lieferanspruch_modal_factor_union',
  documents_widget_title = 'documents_widget_title',
  documents_widget_view_all = 'documents_widget_view_all',
  documents_list_title = 'documents_list_title',
  documents_list_no_documents_found = 'documents_list_no_documents_found',
  documents_list_preview_document = 'documents_list_preview_document',
  documents_list_download_document = 'documents_list_download_document',
  documents_list_column_header_filename = 'documents_list_column_header_filename',
  documents_list_column_header_businessYear = 'documents_list_column_header_businessYear',
  documents_list_column_header_creationDate = 'documents_list_column_header_creationDate',
  documents_list_column_header_actions = 'documents_list_column_header_actions',
  documents_list_column_header_category = 'documents_list_column_header_category',
  documents_list_column_header_category_filter_close_button = 'documents_list_column_header_category_filter_close_button',
  individual_documents_list_category_contract = 'individual_documents_list_category_contract',
  individual_documents_list_category_payments = 'individual_documents_list_category_payments',
  individual_documents_list_category_newsletter = 'individual_documents_list_category_newsletter',
  individual_documents_list_category_business_info_beet = 'individual_documents_list_category_business_info_beet',
  individual_documents_list_category_my_upload = 'individual_documents_list_category_my_upload',
  individual_documents_list_category_unknown = 'individual_documents_list_category_unknown',
  news_preview_no_selected = 'news_preview_no_selected',
  news_preview_date_not_available = 'news_preview_date_not_available',
  news_preview_no_article_selected = 'news_preview_no_article_selected',
  document_list_column_header_invoiceId = 'document_list_column_header_invoiceId',
  unauthoricated_home_welcome = 'unauthoricated_home_welcome',
  unauthoricated_home_prompt = 'unauthoricated_home_prompt',
  my_payments_full_financial_report = 'my_payments_full_financial_report',
  my_payments_documents_list_title = 'my_payments_documents_list_title',
  my_payments_title = 'my_payments_title',
  contract_fullfilment_title = 'contract_fullfilment_title',
  welcomemodal_title = 'welcomemodal_title',
  welcomemodal_paragraph_large = 'welcomemodal_paragraph_large',
  welcomemodal_paragraph_small1 = 'welcomemodal_paragraph_small1',
  welcomemodal_paragraph_small2 = 'welcomemodal_paragraph_small2',
  welcomemodal_input_title = 'welcomemodal_input_title',
  welcomemodal_input_placeholder = 'welcomemodal_input_placeholder',
  welcomemodal_button_proceed = 'welcomemodal_button_proceed',
  welcomemodal_button_skip = 'welcomemodal_button_skip',
  welcomemodal_input_error_empty = 'welcomemodal_input_error_empty',
  welcomemodal_input_error_length = 'welcomemodal_input_error_length',
  profile_input_error_empty = 'profile_input_error_empty',
  profile_input_error_length = 'profile_input_error_length',
  documents_list_button_view_all = 'documents_list_button_view_all',
  end_aob_button = 'end_aob_button',
  home_documents_widget_title = 'home_documents_widget_title',
  contracts_documents_widget_title = 'contracts_documents_widget_title',
  pagenotfound_title = 'pagenotfound_title',
  pagenotfound_message = 'pagenotfound_message',
  pagenotfound_link_text = 'pagenotfound_link_text',
  login_button = 'login_button',
  loggedOutPage_title = 'loggedOutPage_title',
  loggedOutPage_button_login = 'loggedOutPage_button_login',
  loggedOutPage_footer_imprint = 'loggedOutPage_footer_imprint',
  loggedOutPage_footer_dataProtection = 'loggedOutPage_footer_dataProtection',
  loggedOutPage_footer_terms = 'loggedOutPage_footer_terms',
  loggedOutPage_footer_copyright = 'loggedOutPage_footer_copyright',
  loggedOutPage_cropConnect = 'loggedOutPage_cropConnect',
  loggedOutPage_byNordzucker = 'loggedOutPage_byNordzucker',
  error_boundary_title = 'error_boundary_title',
  error_boundary_message = 'error_boundary_message',
  error_boundary_cta = 'error_boundary_cta',
  admin_translation_back_to_home = 'admin_translation_back_to_home',
  administrationPage_title = 'administrationPage_title',
  calendar_week = 'calendar_week',
  error_fetching_data = 'error_fetching_data',
  no_additional_data_for_provider = 'no_additional_data_for_provider',
  my_campaign_loading_delivery_plans = 'my_campaign_loading_delivery_plans',
  my_campaign_delivery_plan = 'my_campaign_delivery_plan',
  my_campaign_footer_description = 'my_campaign_footer_description',
  my_delivery_plan_column_delivery_date = 'my_delivery_plan_column_delivery_date',
  my_delivery_plan_column_field_name = 'my_delivery_plan_column_field_name',
  my_delivery_plan_column_area_ha = 'my_delivery_plan_column_area_ha',
  my_delivery_plan_column_load_tons = 'my_delivery_plan_column_load_tons',
  my_delivery_plan_column_transporter = 'my_delivery_plan_column_transporter',
  my_delivery_plan_column_pile_coverer = 'my_delivery_plan_column_pile_coverer',
  my_delivery_plan_own_choice = 'my_delivery_plan_own_choice',
  my_delivery_plan_no_planned_deliveries = 'my_delivery_plan_no_planned_deliveries',
  calendar_week_with_number = 'calendar_week_with_number',
  my_delivery_plan_placeholder_load_date = 'my_delivery_plan_placeholder_load_date',
  my_delivery_plan_placeholder_load_quantity = 'my_delivery_plan_placeholder_load_quantity',
  my_delivery_plan_placeholder_area = 'my_delivery_plan_placeholder_area',
  my_delivery_plan_placeholder_field_name = 'my_delivery_plan_placeholder_field_name',
  my_delivery_plan_placeholder_transporter = 'my_delivery_plan_placeholder_transporter',
  my_delivery_plan_placeholder_pile_coverer = 'my_delivery_plan_placeholder_pile_coverer',
  my_delivery_plan_placeholder_default = 'my_delivery_plan_placeholder_default',
  my_delivery_plan_download = 'my_delivery_plan_download',
  my_delivery_plan_settings = 'my_delivery_plan_settings',
  administration_grower_group_label = 'administration_grower_group_label',
  administration_show_delivery_plan_label = 'administration_show_delivery_plan_label',
  administration_not_visible_message_placeholder = 'administration_not_visible_message_placeholder',
  administration_not_visible_message_label = 'administration_not_visible_message_label',
  administration_days_ahead_label = 'administration_days_ahead_label',
  administration_delivery_plan_section_title = 'administration_delivery_plan_section_title',
  cancel_button = 'cancel_button',
  save_button = 'save_button',
  delivery_plan_saved_message = 'delivery_plan_saved_message',
  serviceprovider_additional_info_placeholder = 'serviceprovider_additional_info_placeholder',
  serviceprovider_deliveryplan_administration_header = 'serviceprovider_deliveryplan_administration_header',
  administration_delivery_plan_settings_title = 'administration_delivery_plan_settings_title',
  bannerpl_title = 'bannerpl_title',
  bannerpl_subtitle = 'bannerpl_subtitle',
  bannerpl_image_alt = 'bannerpl_image_alt',
  agrenordbanner_title = 'agrenordbanner_title',
  agrenordbanner_subtitle = 'agrenordbanner_subtitle',
  agrenordbanner_alt = 'agrenordbanner_alt',
  delivery_plan_no_additional_info = 'delivery_plan_no_additional_info',
  eshop_banner_text = 'eshop_banner_text',
  eshop_modal_title = 'eshop_modal_title',
  eshop_modal_content_prefix = 'eshop_modal_content_prefix',
  eshop_modal_content_suffix = 'eshop_modal_content_suffix',
  eshop_modal_business_partner = 'eshop_modal_business_partner',
  common_cancel = 'common_cancel',
  common_confirm = 'common_confirm',
  administration_translations = 'administration_translations',
  delivery_plan_table_footer = 'delivery_plan_table_footer',
  administration_statistics_title = 'administration_statistics_title',
  administration_statistics_get_bp_statistic_button = 'administration_statistics_get_bp_statistic_button',
  administration_statistics_get_user_statistic_button = 'administration_statistics_get_user_statistic_button',
  field_nomination_banner_text = 'field_nomination_banner_text',
  my_contracts_e_contracting_button = 'my_contracts_e_contracting_button',
  dateRangePicker_start_date = 'dateRangePicker_start_date',
  dateRangePicker_end_date = 'dateRangePicker_end_date',
  dateRangePicker_clear_dates = 'dateRangePicker_clear_dates',
  dateRangePicker_enter_correct_date = 'dateRangePicker_enter_correct_date',
  my_tasks_survey_available = 'my_tasks_survey_available',
  my_tasks_fill_survey = 'my_tasks_fill_survey',
  survey_redcert_section_title = 'survey_redcert_section_title',
  hint_input_placeholder = 'hint_input_placeholder',
  hint_more_information = 'hint_more_information',
  daterangepicker_start_time = 'daterangepicker_start_time',
  daterangepicker_end_time = 'daterangepicker_end_time',
  invekos_number_label = 'invekos_number_label',
  invekos_number_error = 'invekos_number_error',
  survey_form_modal_last_saved_by = 'survey_form_modal_last_saved_by',
  survey_form_modal_last_saved_on = 'survey_form_modal_last_saved_on',
  survey_form_modal_invekos_number = 'survey_form_modal_invekos_number',
  survey_form_modal_consent_error = 'survey_form_modal_consent_error',
  survey_form_modal_cancel_button = 'survey_form_modal_cancel_button',
  survey_form_modal_confirm_cancel_button = 'survey_form_modal_confirm_cancel_button',
  survey_form_modal_submit_button = 'survey_form_modal_submit_button',
  survey_form_modal_required_field = 'survey_form_modal_required_field',
  survey_form_modal_success_message = 'survey_form_modal_success_message',
  survey_form_modal_close_modal_title = 'survey_form_modal_close_modal_title',
  survey_form_modal_close_modal_content = 'survey_form_modal_close_modal_content',
  survey_form_modal_close_modal_confirm = 'survey_form_modal_close_modal_confirm',
  confirm_action_modal_cancel_button = 'confirm_action_modal_cancel_button',
  confirm_action_modal_delete_button = 'confirm_action_modal_delete_button',
  survey_form_create_new_survey = 'survey_form_create_new_survey',
  survey_form_survey_name = 'survey_form_survey_name',
  survey_form_survey_description = 'survey_form_survey_description',
  survey_form_add_survey_hint = 'survey_form_add_survey_hint',
  survey_form_survey_hint = 'survey_form_survey_hint',
  survey_form_cancel = 'survey_form_cancel',
  survey_form_create_survey = 'survey_form_create_survey',
  survey_form_saving = 'survey_form_saving',
  survey_form_survey_title = 'survey_form_survey_title',
  survey_form_edit_title = 'survey_form_edit_title',
  survey_form_save_title = 'survey_form_save_title',
  survey_form_survey_hint_section = 'survey_form_survey_hint_section',
  survey_form_edit_hint = 'survey_form_edit_hint',
  survey_form_save_hint = 'survey_form_save_hint',
  survey_form_survey_description_section = 'survey_form_survey_description_section',
  survey_form_edit_description = 'survey_form_edit_description',
  survey_form_save_description = 'survey_form_save_description',
  survey_form_survey_date_range = 'survey_form_survey_date_range',
  survey_form_edit_dates = 'survey_form_edit_dates',
  survey_form_save_dates = 'survey_form_save_dates',
  survey_form_save_survey = 'survey_form_save_survey',
  survey_list_create_new_survey = 'survey_list_create_new_survey',
  survey_list_create_new_survey_disabled_tooltip = 'survey_list_create_new_survey_disabled_tooltip',
  survey_list_table_header_name = 'survey_list_table_header_name',
  survey_list_table_header_type = 'survey_list_table_header_type',
  survey_list_table_header_start_date = 'survey_list_table_header_start_date',
  survey_list_table_header_start_time = 'survey_list_table_header_start_time',
  survey_list_table_header_end_date = 'survey_list_table_header_end_date',
  survey_list_table_header_end_time = 'survey_list_table_header_end_time',
  survey_list_table_header_actions = 'survey_list_table_header_actions',
  survey_list_loading = 'survey_list_loading',
  survey_list_error_loading = 'survey_list_error_loading',
  survey_list_no_surveys = 'survey_list_no_surveys',
  survey_list_action_edit = 'survey_list_action_edit',
  survey_list_action_delete = 'survey_list_action_delete',
  survey_list_delete_modal_title = 'survey_list_delete_modal_title',
  survey_list_delete_modal_confirm_generic = 'survey_list_delete_modal_confirm_generic',
  survey_list_delete_modal_warning = 'survey_list_delete_modal_warning',
  survey_list_delete_modal_confirm_single = 'survey_list_delete_modal_confirm_single',
  survey_question_controls_save_question = 'survey_question_controls_save_question',
  survey_question_controls_edit_question = 'survey_question_controls_edit_question',
  survey_question_controls_remove_question = 'survey_question_controls_remove_question',
  survey_question_form_question_title = 'survey_question_form_question_title',
  survey_question_form_updating = 'survey_question_form_updating',
  survey_question_form_update = 'survey_question_form_update',
  survey_question_form_deleting = 'survey_question_form_deleting',
  survey_question_form_delete = 'survey_question_form_delete',
  survey_question_form_saved = 'survey_question_form_saved',
  survey_question_form_edit = 'survey_question_form_edit',
  survey_question_form_saving = 'survey_question_form_saving',
  survey_question_form_save_question = 'survey_question_form_save_question',
  survey_question_form_question_type = 'survey_question_form_question_type',
  survey_question_form_answer_type = 'survey_question_form_answer_type',
  survey_question_form_question_header = 'survey_question_form_question_header',
  survey_question_form_question_header_placeholder = 'survey_question_form_question_header_placeholder',
  survey_question_form_question = 'survey_question_form_question',
  survey_question_form_question_placeholder = 'survey_question_form_question_placeholder',
  survey_question_form_prefilled_answer = 'survey_question_form_prefilled_answer',
  survey_question_form_prefilled_answer_placeholder = 'survey_question_form_prefilled_answer_placeholder',
  survey_question_form_question_type_standard = 'survey_question_form_question_type_standard',
  survey_question_form_question_type_prefilled = 'survey_question_form_question_type_prefilled',
  survey_question_form_answer_type_single_choice = 'survey_question_form_answer_type_single_choice',
  survey_question_form_answer_type_textarea = 'survey_question_form_answer_type_textarea',
  survey_question_form_positive_answer = 'survey_question_form_positive_answer',
  survey_question_form_negative_answer = 'survey_question_form_negative_answer',
  survey_question_form_remove_answer_option = 'survey_question_form_remove_answer_option',
  survey_question_form_add_answer_option = 'survey_question_form_add_answer_option',
  survey_question_form_max_options = 'survey_question_form_max_options',
  survey_question_form_add_hint = 'survey_question_form_add_hint',
  survey_question_form_hint_placeholder = 'survey_question_form_hint_placeholder',
  survey_question_form_add_hint_label = 'survey_question_form_add_hint_label',
  survey_question_type_selector_question_type_label = 'survey_question_type_selector_question_type_label',
  survey_question_type_selector_question_type_standard = 'survey_question_type_selector_question_type_standard',
  survey_question_type_selector_question_type_prefilled = 'survey_question_type_selector_question_type_prefilled',
  survey_question_type_selector_answer_type_label = 'survey_question_type_selector_answer_type_label',
  survey_question_type_selector_answer_type_single_choice = 'survey_question_type_selector_answer_type_single_choice',
  survey_question_type_selector_answer_type_textarea = 'survey_question_type_selector_answer_type_textarea',
  survey_question_type_selector_cancel = 'survey_question_type_selector_cancel',
  survey_question_type_selector_add = 'survey_question_type_selector_add',
  survey_questions_title = 'survey_questions_title',
  survey_questions_add_question = 'survey_questions_add_question',
  survey_questions_delete_modal_title = 'survey_questions_delete_modal_title',
  survey_questions_delete_modal_content = 'survey_questions_delete_modal_content',
  survey_questions_delete_modal_content_generic = 'survey_questions_delete_modal_content_generic',
  survey_questions_delete_modal_content_with_text = 'survey_questions_delete_modal_content_with_text',
  administration_tab_delivery_plan = 'administration_tab_delivery_plan',
  administration_tab_redcert = 'administration_tab_redcert',
  survey_form_survey_consents_section = 'survey_form_survey_consents_section',
  survey_form_edit_consents = 'survey_form_edit_consents',
  survey_form_save_consents = 'survey_form_save_consents',
  survey_form_hint_for_invekos = 'survey_form_hint_for_invekos',
  survey_form_main_consent = 'survey_form_main_consent',
  survey_form_additional_consent = 'survey_form_additional_consent',
  survey_form_hint_for_invekos_title = 'survey_form_hint_for_invekos_title',
  survey_form_success_message_title = 'survey_form_success_message_title',
  survey_form_success_confirm_button = 'survey_form_success_confirm_button',
  survey_form_modal_invekos_header = 'survey_form_modal_invekos_header',
  survey_form_modal_incomplete_answers_warning = 'survey_form_modal_incomplete_answers_warning',
  invekos_number_invalid = 'invekos_number_invalid',
  general_document_copy_link = 'general_document_copy_link',
  general_document_move_up = 'general_document_move_up',
  general_document_move_down = 'general_document_move_down',
  general_document_edit = 'general_document_edit',
  general_document_delete = 'general_document_delete',
  general_document_loading = 'general_document_loading',
  create_general_document_banner_title = 'create_general_document_banner_title',
  create_general_document_banner_headline = 'create_general_document_banner_headline',
  create_general_document_banner_text = 'create_general_document_banner_text',
  create_general_document_banner_document = 'create_general_document_banner_document',
  create_general_document_banner_color = 'create_general_document_banner_color',
  create_general_document_list_title = 'create_general_document_list_title',
  create_general_document_document_name = 'create_general_document_document_name',
  create_general_document_list_subheadline = 'create_general_document_list_subheadline',
  general_document_admin_title = 'general_document_admin_title',
  general_document_admin_add_new_document_list_button = 'general_document_admin_add_new_document_list_button',
  general_document_admin_add_new_document_banner_button = 'general_document_admin_add_new_document_banner_button',
  general_document_cancel_button = 'general_document_cancel_button',
  general_document_save_button = 'general_document_save_button',
  general_document_create_button = 'general_document_create_button',
  general_document_remove_document_button = 'general_document_remove_document_button',
  general_document_add_document_button = 'general_document_add_document_button',
  general_document_add_subheadline_button = 'general_document_add_subheadline_button',
  general_document_remove_subheadline_button = 'general_document_remove_subheadline_button',
  general_document_delete_warning_title = 'general_document_delete_warning_title',
  general_document_ok_button = 'general_document_ok_button',
  my_tasks_admin_title = 'my_tasks_admin_title',
  my_tasks_admin_select_country_label = 'my_tasks_admin_select_country_label',
  my_tasks_table_header_headline = 'my_tasks_table_header_headline',
  my_tasks_table_header_type = 'my_tasks_table_header_type',
  my_tasks_table_header_start_date = 'my_tasks_table_header_start_date',
  my_tasks_table_header_end_date = 'my_tasks_table_header_end_date',
  my_tasks_table_header_status = 'my_tasks_table_header_status',
  my_tasks_table_header_action = 'my_tasks_table_header_action',
  my_tasks_valid = 'my_tasks_valid',
  my_tasks_expired = 'my_tasks_expired',
  my_tasks_admin_create_button = 'my_tasks_admin_create_button',
  my_tasks_admin_action_edit_button = 'my_tasks_admin_action_edit_button',
  my_tasks_admin_action_delete_button = 'my_tasks_admin_action_delete_button',
  my_tasks_admin_delete_confirmation = 'my_tasks_admin_delete_confirmation',
  my_tasks_widget_title = 'my_tasks_widget_title',
  my_tasks_widget_manage_button = 'my_tasks_widget_manage_button',
  my_tasks_create_modal_title = 'my_tasks_create_modal_title',
  my_tasks_create_modal_headline = 'my_tasks_create_modal_headline',
  my_tasks_create_modal_description = 'my_tasks_create_modal_description',
  my_tasks_create_modal_task_type = 'my_tasks_create_modal_task_type',
  my_tasks_create_modal_external_url = 'my_tasks_create_modal_external_url',
  my_tasks_create_modal_internal_url = 'my_tasks_create_modal_internal_url',
  my_tasks_create_modal_eshop = 'my_tasks_create_modal_eshop',
  my_tasks_create_modal_econtracting = 'my_tasks_create_modal_econtracting',
  my_tasks_create_modal_field_map = 'my_tasks_create_modal_field_map',
  my_tasks_create_modal_redcert = 'my_tasks_create_modal_redcert',
  my_tasks_create_modal_general_document = 'my_tasks_create_modal_general_document',
  my_tasks_create_modal_survey = 'my_tasks_create_modal_survey',
  my_tasks_create_modal_external_url_input = 'my_tasks_create_modal_external_url_input',
  my_tasks_create_modal_internal_url_input = 'my_tasks_create_modal_internal_url_input',
  my_tasks_create_modal_general_document_input = 'my_tasks_create_modal_general_document_input',
  my_tasks_create_modal_redcert_input = 'my_tasks_create_modal_redcert_input',
  my_tasks_create_modal_survey_csv_input = 'my_tasks_create_modal_survey_csv_input',
  my_tasks_create_modal_valid_from = 'my_tasks_create_modal_valid_from',
  my_tasks_create_modal_valid_from_time = 'my_tasks_create_modal_valid_from_time',
  my_tasks_create_modal_valid_to = 'my_tasks_create_modal_valid_to',
  my_tasks_create_modal_valid_to_time = 'my_tasks_create_modal_valid_to_time',
  my_tasks_create_modal_assignment_type = 'my_tasks_create_modal_assignment_type',
  my_tasks_create_modal_roles = 'my_tasks_create_modal_roles',
  my_tasks_create_modal_single = 'my_tasks_create_modal_single',
  my_tasks_create_modal_roles_select = 'my_tasks_create_modal_roles_select',
  my_tasks_create_modal_single_input = 'my_tasks_create_modal_single_input',
  my_tasks_create_modal_cancel = 'my_tasks_create_modal_cancel',
  my_tasks_create_modal_save = 'my_tasks_create_modal_save',
  my_tasks_create_modal_create = 'my_tasks_create_modal_create',
  my_tasks_csv_invalid_warning_message = 'my_tasks_csv_invalid_warning_message',
  samplefrequency_widget_title = 'samplefrequency_widget_title',
  samplefrequency_table_header_cell_sample = 'samplefrequency_table_header_cell_sample',
  samplefrequency_table_header_cell_devlivery_category = 'samplefrequency_table_header_cell_devlivery_category',
  beetprice_widget_title = 'beetprice_widget_title',
  beetprice_table_header_cell_year = 'beetprice_table_header_cell_year',
  beetprice_table_header_cell_price = 'beetprice_table_header_cell_price',
  generaldocuments_picker_back_option = 'generaldocuments_picker_back_option',
  generaldocuments_picker_open_picker_button = 'generaldocuments_picker_open_picker_button',
  generaldocuments_picker_header = 'generaldocuments_picker_header',
  generaldocuments_picker_loading_info = 'generaldocuments_picker_loading_info',
  individual_documents_widget_anbauempfehlung_title = 'individual_documents_widget_anbauempfehlung_title',
  individual_documents_widget_newsletters_title = 'individual_documents_widget_newsletters_title',
  individual_documents_widget_liefermitteilungen_title = 'individual_documents_widget_liefermitteilungen_title',
  individual_documents_title = 'individual_documents_title',
  general_document_delete_subheadline_warning = 'general_document_delete_subheadline_warning',
  create_general_document_modal_choose_document = 'create_general_document_modal_choose_document',
  masterdata_transport_explaination_note = 'masterdata_transport_explaination_note',
  masterdata_headline_title_label = 'masterdata_headline_title_label',
  masterdata_headline_name_label = 'masterdata_headline_name_label',
  masterdata_headline_bpNumber_label = 'masterdata_headline_bpNumber_label',
  masterdata_headline_office_label = 'masterdata_headline_office_label',
  masterdata_headline_euFarmNumber_label = 'masterdata_headline_euFarmNumber_label',
  masterdata_headline_personalIdentityCardNumber_label = 'masterdata_headline_personalIdentityCardNumber_label',
  masterdata_headline_personalIdentityCardValidFrom_label = 'masterdata_headline_personalIdentityCardValidFrom_label',
  masterdata_headline_socialSecurityNumber_label = 'masterdata_headline_socialSecurityNumber_label',
  masterdata_headline_street_label = 'masterdata_headline_street_label',
  masterdata_headline_houseNo_label = 'masterdata_headline_houseNo_label',
  masterdata_headline_street5_label = 'masterdata_headline_street5_label',
  masterdata_headline_postalCode_label = 'masterdata_headline_postalCode_label',
  masterdata_headline_city_label = 'masterdata_headline_city_label',
  masterdata_headline_district_label = 'masterdata_headline_district_label',
  masterdata_headline_telephone_label = 'masterdata_headline_telephone_label',
  masterdata_headline_fax_label = 'masterdata_headline_fax_label',
  masterdata_headline_mail_label = 'masterdata_headline_mail_label',
  masterdata_headline_bankName_label = 'masterdata_headline_bankName_label',
  masterdata_headline_bankAccountNr_label = 'masterdata_headline_bankAccountNr_label',
  masterdata_headline_bankCode_label = 'masterdata_headline_bankCode_label',
  masterdata_headline_iban_label = 'masterdata_headline_iban_label',
  masterdata_headline_taxNumber_label = 'masterdata_headline_taxNumber_label',
  masterdata_headline_vatNumber_label = 'masterdata_headline_vatNumber_label',
  masterdata_headline_vatOrRR_label = 'masterdata_headline_vatOrRR_label',
  masterdata_headline_bezugspunkt_label = 'masterdata_headline_bezugspunkt_label',
  masterdata_headline_bzpInKm_label = 'masterdata_headline_bzpInKm_label',
  masterdata_headline_frachtsatzUeberrueben_label = 'masterdata_headline_frachtsatzUeberrueben_label',
  masterdata_headline_frachtsatzProdukte_label = 'masterdata_headline_frachtsatzProdukte_label',
  masterdata_section_general_label = 'masterdata_section_general_label',
  masterdata_section_address_label = 'masterdata_section_address_label',
  masterdata_section_communication_label = 'masterdata_section_communication_label',
  masterdata_section_bankAndVat_label = 'masterdata_section_bankAndVat_label',
  masterdata_section_transport_label = 'masterdata_section_transport_label',
  individual_documents_widget_inbox_title = 'individual_documents_widget_inbox_title',
  all_individual_documents_list_title = 'all_individual_documents_list_title',
  document_widget_unread_indicator = 'document_widget_unread_indicator',
  individual_documents_main_newsletters_title = 'individual_documents_main_newsletters_title',
  individual_documents_main_anbauempfehlung_title = 'individual_documents_main_anbauempfehlung_title',
  individual_documents_main_liefermitteilungen_title = 'individual_documents_main_liefermitteilungen_title',
  noncloseable_welcomemodal_title = 'noncloseable_welcomemodal_title',
  noncloseable_welcomemodal_paragraph_1 = 'noncloseable_welcomemodal_paragraph_1',
  noncloseable_welcomemodal_paragraph_2 = 'noncloseable_welcomemodal_paragraph_2',
  noncloseable_welcomemodal_paragraph_3 = 'noncloseable_welcomemodal_paragraph_3',
  on_switching_BP_warning_modal_title = 'on_switching_BP_warning_modal_title',
  on_switching_BP_warning_modal_paragraph_1 = 'on_switching_BP_warning_modal_paragraph_1',
  on_switching_BP_warning_modal_paragraph_2 = 'on_switching_BP_warning_modal_paragraph_2',
  on_switching_BP_warning_modal_paragraph_3 = 'on_switching_BP_warning_modal_paragraph_3',
  on_switching_BP_warning_modal_paragraph_4 = 'on_switching_BP_warning_modal_paragraph_4',
  on_switching_BP_warning_modal_paragraph_5 = 'on_switching_BP_warning_modal_paragraph_5',
  on_switching_BP_warning_modal_close_button = 'on_switching_BP_warning_modal_close_button',
  bannerapc_title = 'bannerapc_title',
  bannerapc_subtitle = 'bannerapc_subtitle',
  bannerapc_image_alt = 'bannerapc_image_alt',

  //#region Variety Planner
  variety_planner_form_response_no = 'variety_planner_form_response_no',
  variety_planner_form_response_yes = 'variety_planner_form_response_yes',
  variety_planner_form_response_neutral = 'variety_planner_form_response_neutral',
  variety_planner_modal_title = 'variety_planner_modal_title',
  variety_planner_modal_description = 'variety_planner_modal_description',
  variety_planner_no_filters_text = 'variety_planner_no_filters_text',
  variety_planner_filters_applied_text = 'variety_planner_filters_applied_text',
  variety_planner_form_info_text_1 = 'variety_planner_form_info_text_1',
  variety_planner_form_info_text_2 = 'variety_planner_form_info_text_2',
  variety_planner_clear_filters_button_text = 'variety_planner_clear_filters_button_text',
  variety_planner_filters_see_less_btn_text = 'variety_planner_filters_see_less_btn_text',
  variety_planner_filters_see_more_btn_text = 'variety_planner_filters_see_more_btn_text',
  variety_planner_table_section_title = 'variety_planner_table_section_title',
  variety_planner_table_loading_text = 'variety_planner_table_loading_text',
  variety_planner_table_loading_more_text = 'variety_planner_table_loading_more_text',
  variety_planner_table_error_loading_data = 'variety_planner_table_error_loading_data',
  varietyPlanner_Q_1 = 'varietyPlanner_Q_1',
  varietyPlanner_Q_1_YES_TAG = 'varietyPlanner_Q_1_YES_TAG',
  varietyPlanner_Q_1_NO_TAG = 'varietyPlanner_Q_1_NO_TAG',
  varietyPlanner_Q_2 = 'varietyPlanner_Q_2',
  varietyPlanner_Q_2_YES_TAG = 'varietyPlanner_Q_2_YES_TAG',
  varietyPlanner_Q_2_NO_TAG = 'varietyPlanner_Q_2_NO_TAG',
  varietyPlanner_Q_3 = 'varietyPlanner_Q_3',
  varietyPlanner_Q_3_YES_TAG = 'varietyPlanner_Q_3_YES_TAG',
  varietyPlanner_Q_3_NEUTRAL_TAG = 'varietyPlanner_Q_3_NEUTRAL_TAG',
  varietyPlanner_Q_3_NO_TAG = 'varietyPlanner_Q_3_NO_TAG',
  varietyPlanner_Q_4 = 'varietyPlanner_Q_4',
  varietyPlanner_Q_4_YES_TAG = 'varietyPlanner_Q_4_YES_TAG',
  varietyPlanner_Q_4_NEUTRAL_TAG = 'varietyPlanner_Q_4_NEUTRAL_TAG',
  varietyPlanner_Q_4_NO_TAG = 'varietyPlanner_Q_4_NO_TAG',
  varietyPlanner_Q_5 = 'varietyPlanner_Q_5',
  varietyPlanner_Q_5_YES_TAG = 'varietyPlanner_Q_5_YES_TAG',
  varietyPlanner_Q_5_NO_TAG = 'varietyPlanner_Q_5_NO_TAG',
  varietyPlanner_Q_6 = 'varietyPlanner_Q_6',
  varietyPlanner_Q_6_YES_TAG = 'varietyPlanner_Q_6_YES_TAG',
  varietyPlanner_Q_6_NEUTRAL_TAG = 'varietyPlanner_Q_6_NEUTRAL_TAG',
  varietyPlanner_Q_6_NO_TAG = 'varietyPlanner_Q_6_NO_TAG',
  varietyPlanner_Q_7 = 'varietyPlanner_Q_7',
  varietyPlanner_Q_7_Q_7_A_R = 'varietyPlanner_Q_7_Q_7_A_R',
  varietyPlanner_Q_7_Q_7_A_G = 'varietyPlanner_Q_7_Q_7_A_G',
  varietyPlanner_Q_7_Q_7_A_B = 'varietyPlanner_Q_7_Q_7_A_B',
  varietyPlanner_Product_CH_0 = 'varietyPlanner_Product_CH_0',
  varietyPlanner_Product_CH_1 = 'varietyPlanner_Product_CH_1',
  varietyPlanner_Product_CH_2 = 'varietyPlanner_Product_CH_2',
  varietyPlanner_Product_CH_3 = 'varietyPlanner_Product_CH_3',
  varietyPlanner_Product_CH_4 = 'varietyPlanner_Product_CH_4',
  varietyPlanner_Product_CH_5 = 'varietyPlanner_Product_CH_5',
  varietyPlanner_Product_CH_6 = 'varietyPlanner_Product_CH_6',
  varietyPlanner_Product_CH_7 = 'varietyPlanner_Product_CH_7',
  varietyPlanner_Banner_title = 'varietyPlanner_Banner_title',
  varietyPlanner_Banner_subtitle = 'varietyPlanner_Banner_subtitle',
  varietyPlanner_Q_1_Abbreviation = 'varietyPlanner_Q_1_Abbreviation',
  varietyPlanner_Q_2_Abbreviation = 'varietyPlanner_Q_2_Abbreviation',
  varietyPlanner_Q_3_Abbreviation = 'varietyPlanner_Q_3_Abbreviation',
  varietyPlanner_Q_4_Abbreviation = 'varietyPlanner_Q_4_Abbreviation',
  varietyPlanner_Q_5_Abbreviation = 'varietyPlanner_Q_5_Abbreviation',
  varietyPlanner_Q_6_Abbreviation = 'varietyPlanner_Q_6_Abbreviation',
  varietyPlanner_Q_7_Abbreviation = 'varietyPlanner_Q_7_Abbreviation',
  varietyPlanner_Q_1_Info = 'varietyPlanner_Q_1_Info',
  varietyPlanner_Q_2_Info = 'varietyPlanner_Q_2_Info',
  varietyPlanner_Q_3_Info = 'varietyPlanner_Q_3_Info',
  varietyPlanner_Q_4_Info = 'varietyPlanner_Q_4_Info',
  varietyPlanner_Q_5_Info = 'varietyPlanner_Q_5_Info',
  varietyPlanner_Q_6_Info = 'varietyPlanner_Q_6_Info',
  varietyPlanner_Q_7_Info = 'varietyPlanner_Q_7_Info',
  variety_planner_footnotes = 'variety_planner_footnotes',
  varietyPlanner_legend_recommended_products = 'varietyPlanner_legend_recommended_products',
  varietyPlanner_legend_neutral_products = 'varietyPlanner_legend_neutral_products',
  varietyPlanner_legend_not_recommended_products = 'varietyPlanner_legend_not_recommended_products',
  // #endregion Variety Planner
  general_document_admin_add_new_upload_banner_button = 'general_document_admin_add_new_upload_banner_button',
  create_upload_banner_title = 'create_upload_banner_title',
  create_upload_banner_headline = 'create_upload_banner_headline',
  create_upload_banner_text = 'create_upload_banner_text',
  create_upload_banner_document_type = 'create_upload_banner_document_type',
  upload_document_banner_title = 'upload_document_banner_title',
  upload_document_banner_document_type = 'upload_document_banner_document_type',
  upload_document_banner_modal_cancel_button = 'upload_document_banner_modal_cancel_button',
  upload_document_banner_modal_upload_button = 'upload_document_banner_modal_upload_button',
  upload_banner_closing_confirmation_title = 'upload_banner_closing_confirmation_title',
  upload_banner_closing_confirmation_question = 'upload_banner_closing_confirmation_question',
  upload_banner_closing_confirmation_information = 'upload_banner_closing_confirmation_information',
  upload_banner_closing_confirmation_cancel_button = 'upload_banner_closing_confirmation_cancel_button',
  upload_banner_closing_confirmation_continue_button = 'upload_banner_closing_confirmation_continue_button',
  upload_document_banner_confirmation_checkbox_text = 'upload_document_banner_confirmation_checkbox_text',
  file_upload_component_upload_text = 'file_upload_component_upload_text',
  upload_document_banner_success_message_headline = 'upload_document_banner_success_message_headline',
  upload_document_banner_success_message_subheadline_1 = 'upload_document_banner_success_message_subheadline_1',
  upload_document_banner_success_message_subheadline_2 = 'upload_document_banner_success_message_subheadline_2',
  upload_document_banner_error_message_headline = 'upload_document_banner_error_message_headline',
  upload_document_banner_error_message_subheadline_1 = 'upload_document_banner_error_message_subheadline_1',
  upload_document_banner_error_message_subheadline_2 = 'upload_document_banner_error_message_subheadline_2',
  upload_document_banner_modal_start_again_button = 'upload_document_banner_modal_start_again_button',
  file_upload_component_wrong_type_message = 'file_upload_component_wrong_type_message',
  file_upload_component_wrong_size_message = 'file_upload_component_wrong_size_message',
  file_upload_component_selected_file = 'file_upload_component_selected_file',
  upload_document_admin_title = 'upload_document_admin_title',
  alert_confirm_button_text = 'alert_confirm_button_text',
}

type DefaultResource = {
  [K in TranslationKeys]: string;
};

export const defaultResource: DefaultResource = {
  [TranslationKeys.accessonbehalfactivationbox_error_bpnotaccessible]:
    'Not accessible',
  [TranslationKeys.accessonbehalfactivationbox_error_bpnotfound]:
    'Business partner not found',
  [TranslationKeys.accessonbehalfactivationbox_error_invalidbpnumber]:
    'Not allowed to access BP number',
  [TranslationKeys.accessonbehalfactivationbox_placeholder_enterbpName]:
    'Enter BP number',
  [TranslationKeys.businessPartner_select_bp_number]: 'Select BP Number',
  [TranslationKeys.businessPartner_selected_bp]: 'Selected BP',
  [TranslationKeys.businessPartner_recently_used]: 'Recently Used',
  [TranslationKeys.businessPartner_all_bp]: 'All BP',
  [TranslationKeys.businessPartner_placeholder_enterBP]: 'Enter BP',
  [TranslationKeys.change_cookie_settings_btn]: 'Change cookie settings',
  [TranslationKeys.common_back]: 'Back',
  [TranslationKeys.common_closeButton]: 'Close',
  [TranslationKeys.common_dontshowagain]: "Don't show again",
  [TranslationKeys.common_genericerror]: 'An error occurred',
  [TranslationKeys.common_next]: 'Next',
  [TranslationKeys.cookie_declaration]: 'Cookie declaration',
  [TranslationKeys.dataprotection_document_language]: 'Language',
  [TranslationKeys.dataprotection_document_name]: 'Document Name',
  [TranslationKeys.dataprotection_documents]: 'Documents',
  [TranslationKeys.dataprotection_title]: 'Data Protection Policy',
  [TranslationKeys.empty]: '',
  [TranslationKeys.feedbackForm_cancelButton]: 'Cancel',
  [TranslationKeys.feedbackForm_label_agriCenter]: 'Your Agri-Center',
  [TranslationKeys.feedbackForm_label_description]: 'Description',
  [TranslationKeys.feedbackForm_noSelection]: 'No selection',
  [TranslationKeys.feedbackForm_placeholder_description]:
    'Please describe your Experience',
  [TranslationKeys.feedbackForm_submitButton]: 'Submit Feedback',
  [TranslationKeys.feedbackModal_instructions]:
    'If you have any suggestions and ideas or if you experience problems or want to report a bug, please tell us by filling out this form.',
  [TranslationKeys.feedbackModal_subtitle_help]: 'Help us improve CropConnect!',
  [TranslationKeys.feedbackModal_thanks]: 'Thank you!',
  [TranslationKeys.feedbackModal_title_thankYou]: 'Thank you',
  [TranslationKeys.feedbackModal_title_yourFeedback]: 'Your Feedback',
  [TranslationKeys.feedbackSuccessMessage_description]:
    'We treat every feedback seriously and take care of it. Thank you for helping us make CropConnect a better product.',
  [TranslationKeys.feedbackSuccessMessage_submitted]:
    'Your Feedback has been submitted!',
  [TranslationKeys.feedbackSuccessMessage_thankYou]:
    'Thank you for helping us make CropConnect a better product.',
  [TranslationKeys.feedbackSuccessMessage_title]: 'Thank you',
  [TranslationKeys.feedbackModal_error_generic]:
    'An error occurred while submitting feedback.',
  [TranslationKeys.feedbackModal_error_submission]:
    'Failed to submit feedback. Please try again later.',
  [TranslationKeys.footer_copyright]: '© NORDZUCKER GROUP 2025',
  [TranslationKeys.footer_dataProtection]: 'Data Protection',
  [TranslationKeys.footer_imprint]: 'Imprint',
  [TranslationKeys.footer_submitFeedback]: 'Submit Feedback',
  [TranslationKeys.footer_submitYourFeedbackTitle]: 'Submit Your Feedback',
  [TranslationKeys.footer_termsOfService]: 'Terms of Service',
  [TranslationKeys.imprint_address_line_1]: 'Nordzucker AG',
  [TranslationKeys.imprint_address_line_2]: 'Küchenstraße 9',
  [TranslationKeys.imprint_address_line_3]: '38100 Braunschweig',
  [TranslationKeys.imprint_braunschweig]: '38100 Braunschweig',
  [TranslationKeys.imprint_chairman]: 'CHAIRMAN OF THE SUPERVISORY BOARD',
  [TranslationKeys.imprint_chairman_name]: 'Jochen Johannes Juister',
  [TranslationKeys.imprint_company]: 'Nordzucker AG',
  [TranslationKeys.imprint_company_headquarters]:
    'Company headquarters: Braunschweig',
  [TranslationKeys.imprint_company_register]:
    'Company register: Local court of Braunschweig, HRB 2936',
  [TranslationKeys.imprint_corporate_communications]:
    'CORPORATE COMMUNICATIONS',
  [TranslationKeys.imprint_corporate_communications_text]:
    'Corporate communications',
  [TranslationKeys.imprint_dispute_resolution]:
    'We are neither willing nor committed to take part in an alternative dispute resolution procedure in front of an alternative dispute resolution entity.',
  [TranslationKeys.imprint_editorial_office]: 'EDITORIAL OFFICE',
  [TranslationKeys.imprint_email]: 'E-mail: info@nordzucker.de',
  [TranslationKeys.imprint_executive_board]: 'EXECUTIVE BOARD',
  [TranslationKeys.imprint_executive_board_chairman]:
    'Dr. Lars Gorissen (chairman)',
  [TranslationKeys.imprint_executive_board_member1]: 'Alexander Bott',
  [TranslationKeys.imprint_executive_board_member2]: 'Alexander Godow',
  [TranslationKeys.imprint_information_disclaimer]:
    'All information on the World-Wide-Web server is given to the best of our knowledge, and is based on sources which are believed to be current and correct at the time of publication. We can, however, accept no liability for the correctness and completeness of the information.',
  [TranslationKeys.imprint_kuchenstrasse_9]: 'Küchenstraße 9',
  [TranslationKeys.imprint_local_court]:
    'Local court of Braunschweig, HRB 2936',
  [TranslationKeys.imprint_publisher]: 'PUBLISHER',
  [TranslationKeys.imprint_telephone]: 'Telephone: +49 531-2411-0',
  [TranslationKeys.imprint_title]: 'Imprint',
  [TranslationKeys.imprint_vat_number]:
    'VAT identification number: DE 114883609',
  [TranslationKeys.infocard_readmore]: 'Read more',
  [TranslationKeys.masterdata_masterdata_title]: 'Masterdata',
  [TranslationKeys.masterdata_address_title]: 'Address',
  [TranslationKeys.masterdata_communication_title]: 'Communication',
  [TranslationKeys.masterdata_field_name]: 'Name',
  [TranslationKeys.masterdata_field_anrede]: 'Anrede',
  [TranslationKeys.masterdata_field_bp_number]: 'BP-Number',
  [TranslationKeys.masterdata_field_street]: 'Street, Nr.',
  [TranslationKeys.masterdata_field_zipcode]: 'Zip Code',
  [TranslationKeys.masterdata_field_city]: 'City',
  [TranslationKeys.masterdata_field_district]: 'District',
  [TranslationKeys.masterdata_field_regional_office]: 'Regional Office',
  [TranslationKeys.masterdata_field_bzp]: 'BZP',
  [TranslationKeys.masterdata_field_distance]: 'Distance to BZP in km',
  [TranslationKeys.masterdata_field_phone]: 'Phone',
  [TranslationKeys.masterdata_field_email]: 'Email-Address',
  [TranslationKeys.masterdata_field_fax]: 'Fax',
  [TranslationKeys.my_contracts_title]: 'My Contracts',
  [TranslationKeys.my_contacts_title]: 'My Contacts',
  [TranslationKeys.my_contacts_send_email]: 'Send Email',
  [TranslationKeys.my_contacts_no_contacts_found]: 'No contacts found',
  [TranslationKeys.profilesettings_buttons_saveprofile]: 'SAVE PROFILE',
  [TranslationKeys.profilesettings_profileheader_accountandlogin]:
    'Account & Login',
  [TranslationKeys.profilesettings_profileheader_contactinformation]:
    'Contact Information',
  [TranslationKeys.profilesettings_profileheader_cropconnectsettings]:
    'CropConnect Settings',
  [TranslationKeys.sidebar_beetGrowing]: 'Beet Growing',
  [TranslationKeys.sidebar_data_protection]: 'Data protection',
  [TranslationKeys.sidebar_feedback]: 'Feedback',
  [TranslationKeys.sidebar_help]: 'Help',
  [TranslationKeys.sidebar_home]: 'Start',
  [TranslationKeys.sidebar_imprint]: 'Imprint',
  [TranslationKeys.sidebar_masterdata]: 'Masterdata',
  [TranslationKeys.sidebar_myCampaign]: 'My Campaign',
  [TranslationKeys.sidebar_myContracts]: 'My Contracts',
  [TranslationKeys.sidebar_myFieldsYields]: 'My Fields & Yields',
  [TranslationKeys.sidebar_myOrders]: 'My Orders',
  [TranslationKeys.sidebar_myPayments]: 'My Payments',
  [TranslationKeys.sidebar_nordzucker]: 'Nordzucker',
  [TranslationKeys.sidebar_terms_and_conditions]: 'Terms & conditions',
  [TranslationKeys.sidebar_tools]: 'Tools',
  [TranslationKeys.sidebar_contacts]: 'My Contacts',
  [TranslationKeys.sidebar_agripartner_link]: 'AgriPartner',
  [TranslationKeys.terms_document_language]: 'Language',
  [TranslationKeys.terms_document_name]: 'Document Name',
  [TranslationKeys.terms_documents]: 'Documents',
  [TranslationKeys.terms_title]: 'Terms of Service',
  [TranslationKeys.topbarinternalnavigation_navitem_campaigns]: 'Campaigns',
  [TranslationKeys.topbarinternalnavigation_navitem_contracts]: 'Contracts',
  [TranslationKeys.topbarinternalnavigation_navitem_finances]: 'MyPayments',
  [TranslationKeys.topbarinternalnavigation_navitem_orderedanddeliveredproducts]:
    'Ordered & Delivered Products',
  [TranslationKeys.topbarinternalnavigation_navitem_singlebeetdelivery]:
    'Single Beet Delivery',
  [TranslationKeys.usermenu_item_logout]: 'Logout',
  [TranslationKeys.usermenu_item_username_placeholder]: 'User',
  [TranslationKeys.usermenu_item_profile]: 'Profile',
  [TranslationKeys.mobileHeader_appTitle]: 'CropConnect',
  [TranslationKeys.mobileHeader_subtitle]: 'by Nordzucker',
  [TranslationKeys.mobileHeader_bpNumber]: 'BP Number:',
  [TranslationKeys.homeNews_more_news]: 'More Articles',
  [TranslationKeys.homeNews_read_more]: 'Read More',
  [TranslationKeys.homeNews_welcome_text]: 'Welcome',
  [TranslationKeys.common_back_to_overview]: 'Back to overview',
  [TranslationKeys.common_report_not_released]:
    'This report is not available for your country yet.',
  [TranslationKeys.orderedAndDeliveredProducts_report_title]:
    'Ordered & Delivered Products',
  [TranslationKeys.fieldsAndYields_report_title]: 'My Fields and Yields',
  [TranslationKeys.finances_report_title]: 'Finance Report',
  [TranslationKeys.campaigns_report_title]: 'Single Beet Delivery Report',
  [TranslationKeys.userSettings_pageHeader]: 'Your Profile',
  [TranslationKeys.masterdata_pageHeader]: 'Masterdata',
  [TranslationKeys.userSettings_label_userName]: 'User Name',
  [TranslationKeys.userSettings_label_email]: 'Email',
  [TranslationKeys.userSettings_label_password]: 'Password',
  [TranslationKeys.userSettings_subtitle_contactInformation]:
    'Contact Information',
  [TranslationKeys.userSettings_subtitle_accountSettings]: 'Account Settings',
  [TranslationKeys.userSettings_label_language]: 'Language',
  [TranslationKeys.lieferanspruch_widget_title]: 'Your Delivery Entitlement',
  [TranslationKeys.lieferanspruch_widget_subtitle]: 'Delivery Entitlement',
  [TranslationKeys.lieferanspruch_widget_total_entitlement]:
    'Total Delivery Entitlement',
  [TranslationKeys.lieferanspruch_widget_contracted_amount]:
    'Already Committed in MyContracts',
  [TranslationKeys.lieferanspruch_widget_available_amount]:
    'Not Yet Committed Quantity',
  [TranslationKeys.lieferanspruch_widget_more_info]: 'MORE INFORMATION',
  [TranslationKeys.lieferanspruch_modal_title]: 'Your Delivery Entitlement',
  [TranslationKeys.lieferanspruch_modal_total_entitlement]:
    'Total Delivery Entitlement',
  [TranslationKeys.lieferanspruch_modal_contracted_amount]:
    'Already Committed in MyContracts',
  [TranslationKeys.lieferanspruch_modal_available_amount]:
    'Not Yet Committed Quantity',
  [TranslationKeys.lieferanspruch_modal_subtitle_entitlement_info]:
    'What is the Delivery Entitlement?',
  [TranslationKeys.lieferanspruch_modal_text_entitlement_info_part1]:
    'Delivery entitlement results from the capital shares in the holdings of Nordzucker AG. ' +
    'At Nordzucker Holding AG, the so-called base number is calculated from the shares with ' +
    'the respective historical delivery entitlement per share, which varies depending on the origin. Depending on ' +
    'the total amount required annually, the individual delivery entitlement (base number) ' +
    'is multiplied by the factor (see below).',
  [TranslationKeys.lieferanspruch_modal_text_entitlement_info_part2]:
    'At Union Zucker, the delivery entitlement is derived from the business shares of Union Zucker ' +
    'Südhannover GmbH (base number: share value in € x 0.08) multiplied by the respective ' +
    'subscription factor, which is determined from the total beet quantity needed for Nordzucker AG ' +
    '(see below). The Harsum delivery right is also included in the calculation.',
  [TranslationKeys.lieferanspruch_modal_subtitle_factors]:
    'Subscription Factors',
  [TranslationKeys.lieferanspruch_modal_factor_nz_holding]:
    'Factor for Nordzucker Holding AG for:',
  [TranslationKeys.lieferanspruch_modal_factor_union]:
    'Factor for Union Zucker Südhannover GmbH for:',
  [TranslationKeys.documents_widget_title]: 'Contract Documents',
  [TranslationKeys.documents_widget_view_all]: 'VIEW ALL',
  [TranslationKeys.documents_list_title]: 'Documents',
  [TranslationKeys.documents_list_no_documents_found]:
    'No' + ' documents' + ' found',
  [TranslationKeys.documents_list_preview_document]: 'Preview document',
  [TranslationKeys.documents_list_download_document]: 'Download document',
  [TranslationKeys.documents_list_column_header_filename]: 'Name',
  [TranslationKeys.documents_list_column_header_businessYear]: 'Year',
  [TranslationKeys.documents_list_column_header_creationDate]: 'Creation Date',
  [TranslationKeys.documents_list_column_header_actions]: 'Actions',
  [TranslationKeys.documents_list_column_header_category]: 'Category',
  [TranslationKeys.individual_documents_list_category_contract]: 'Contract',
  [TranslationKeys.individual_documents_list_category_payments]: 'Payments',
  [TranslationKeys.individual_documents_list_category_newsletter]: 'Newsletter',
  [TranslationKeys.individual_documents_list_category_business_info_beet]:
    'Business Info Beet',
  [TranslationKeys.individual_documents_list_category_my_upload]: 'My uploads',
  [TranslationKeys.individual_documents_list_category_unknown]: 'Unknown',
  [TranslationKeys.my_campaign_pageHeader]: 'My Campaign',
  [TranslationKeys.my_campaign_deliveryPlan_button]: 'Delivery Plan',
  [TranslationKeys.news_preview_no_selected]: 'No article selected.',
  [TranslationKeys.news_preview_date_not_available]: 'No date available.',
  [TranslationKeys.news_preview_no_article_selected]: 'No article selected.',
  [TranslationKeys.document_list_column_header_invoiceId]: 'Invoice',
  [TranslationKeys.unauthoricated_home_welcome]: 'Welcome',
  [TranslationKeys.unauthoricated_home_prompt]:
    'Please log in to access more features.',
  [TranslationKeys.my_payments_title]: 'My Payments',
  [TranslationKeys.my_payments_full_financial_report]: 'Full Financial Report',
  [TranslationKeys.my_payments_documents_list_title]: 'Documents',
  [TranslationKeys.welcomemodal_title]: 'Welcome!',
  [TranslationKeys.welcomemodal_paragraph_large]:
    'Nice to have you here. We hope you enjoy this application.',
  [TranslationKeys.welcomemodal_paragraph_small1]:
    'To make the experience even better for you, we ask you to give us a name by which we can address you in this application. If you do not want this, we will use your email address to address you. You can change it any time in the settings.',
  [TranslationKeys.welcomemodal_paragraph_small2]: 'Thank you and have fun.',
  [TranslationKeys.welcomemodal_input_title]:
    'Please enter a name we should call you in this application:',
  [TranslationKeys.welcomemodal_input_placeholder]: 'Name',
  [TranslationKeys.welcomemodal_button_proceed]: 'Proceed',
  [TranslationKeys.welcomemodal_button_skip]: 'Skip',
  [TranslationKeys.welcomemodal_input_error_empty]:
    'Name cannot be empty or just spaces.',
  [TranslationKeys.welcomemodal_input_error_length]:
    'Name cannot exceed 50 characters.',
  [TranslationKeys.profile_input_error_empty]:
    'Display name cannot be empty or just spaces.',
  [TranslationKeys.profile_input_error_length]:
    'Display name cannot exceed 50 characters.',
  [TranslationKeys.contract_fullfilment_title]: 'Contract fulfillment',
  [TranslationKeys.documents_list_button_view_all]: 'View All',
  [TranslationKeys.end_aob_button]: 'End AoB value',
  [TranslationKeys.home_documents_widget_title]: 'My Documents',
  [TranslationKeys.contracts_documents_widget_title]: 'Contract Documents',
  [TranslationKeys.pagenotfound_title]: '404 - Page Not Found',
  [TranslationKeys.pagenotfound_message]:
    'Sorry, the page you are looking for does not exist.',
  [TranslationKeys.pagenotfound_link_text]: 'Go back to homepage',
  [TranslationKeys.login_button]: 'Login',
  [TranslationKeys.loggedOutPage_title]: 'You’re Logged out!',
  [TranslationKeys.loggedOutPage_button_login]: 'To login',
  [TranslationKeys.loggedOutPage_footer_imprint]: 'Imprint',
  [TranslationKeys.loggedOutPage_footer_dataProtection]: 'Data protection',
  [TranslationKeys.loggedOutPage_footer_terms]: 'Terms & Conditions',
  [TranslationKeys.loggedOutPage_footer_copyright]: '© NORDZUCKER GROUP 2025',
  [TranslationKeys.loggedOutPage_cropConnect]: 'CropConnect',
  [TranslationKeys.loggedOutPage_byNordzucker]: 'by Nordzucker',
  [TranslationKeys.error_boundary_title]: 'Oops! Something went wrong.',
  [TranslationKeys.error_boundary_message]:
    "We're sorry for the inconvenience. Please try refreshing the page or\n" +
    '          contact support if the problem persists.',
  [TranslationKeys.error_boundary_cta]: 'Go Home',
  [TranslationKeys.admin_translation_back_to_home]: 'Back to Home',
  [TranslationKeys.administrationPage_title]: 'Administration',
  [TranslationKeys.calendar_week]: 'Week',
  [TranslationKeys.error_fetching_data]: 'Error fetching data',
  [TranslationKeys.no_additional_data_for_provider]:
    'No additional data for provider',
  [TranslationKeys.my_campaign_loading_delivery_plans]:
    'Loading delivery plans...',
  [TranslationKeys.my_campaign_delivery_plan]: 'Delivery Plan',
  [TranslationKeys.my_campaign_footer_description]: 'Footer description',
  [TranslationKeys.my_delivery_plan_column_delivery_date]: 'Delivery Date',
  [TranslationKeys.my_delivery_plan_column_field_name]: 'Field name',
  [TranslationKeys.my_delivery_plan_column_area_ha]: 'Area (ha)',
  [TranslationKeys.my_delivery_plan_column_load_tons]: 'Load (t)',
  [TranslationKeys.my_delivery_plan_column_transporter]: 'Transporter',
  [TranslationKeys.my_delivery_plan_column_pile_coverer]: 'Pile coverer',
  [TranslationKeys.my_delivery_plan_own_choice]: 'Own choice',
  [TranslationKeys.my_delivery_plan_no_planned_deliveries]:
    'No planned deliveries',
  [TranslationKeys.calendar_week_with_number]: 'Week {{number}}',
  [TranslationKeys.my_delivery_plan_placeholder_load_date]:
    'Load Date Placeholder',
  [TranslationKeys.my_delivery_plan_placeholder_load_quantity]:
    'Load Quantity Placeholder',
  [TranslationKeys.my_delivery_plan_placeholder_area]: 'Area Placeholder',
  [TranslationKeys.my_delivery_plan_placeholder_field_name]:
    'Field Name Placeholder',
  [TranslationKeys.my_delivery_plan_placeholder_transporter]:
    'Transporter Placeholder',
  [TranslationKeys.my_delivery_plan_placeholder_pile_coverer]:
    'Pile Coverer Placeholder',
  [TranslationKeys.my_delivery_plan_placeholder_default]: 'Placeholder',
  [TranslationKeys.my_delivery_plan_download]: 'Download',
  [TranslationKeys.my_delivery_plan_settings]: 'Settings',
  [TranslationKeys.administration_grower_group_label]: 'Grower Group',
  [TranslationKeys.administration_show_delivery_plan_label]:
    'Show Delivery Plan',
  [TranslationKeys.administration_not_visible_message_placeholder]:
    'Enter a message',
  [TranslationKeys.administration_not_visible_message_label]:
    'Text displayed when the delivery plan is hidden',
  [TranslationKeys.administration_days_ahead_label]:
    'Number of days ahead when the exact delivery date should be visible',
  [TranslationKeys.administration_delivery_plan_section_title]: 'Delivery Plan',
  [TranslationKeys.cancel_button]: 'Cancel',
  [TranslationKeys.save_button]: 'Save',
  [TranslationKeys.delivery_plan_saved_message]:
    'Settings have been saved successfully.',
  [TranslationKeys.delivery_plan_no_additional_info]:
    'No additional information',
  [TranslationKeys.serviceprovider_additional_info_placeholder]:
    'Additional info that should be displayed in the delivery plan (for ex. your contact data)',
  [TranslationKeys.serviceprovider_deliveryplan_administration_header]:
    'Additional information',
  [TranslationKeys.administration_delivery_plan_settings_title]: 'Settings',
  [TranslationKeys.dateRangePicker_start_date]: 'Start Date',
  [TranslationKeys.dateRangePicker_end_date]: 'End Date',
  [TranslationKeys.dateRangePicker_clear_dates]: 'Clear Dates',
  [TranslationKeys.dateRangePicker_enter_correct_date]:
    'Please enter correct date',
  [TranslationKeys.bannerpl_title]: 'Trial Information',
  [TranslationKeys.bannerpl_subtitle]: 'All about our beet trials',
  [TranslationKeys.bannerpl_image_alt]: 'Trial Information banner',
  [TranslationKeys.agrenordbanner_title]: 'Here you find',
  [TranslationKeys.agrenordbanner_subtitle]: 'Fieldtrials',
  [TranslationKeys.agrenordbanner_alt]: 'Agre Nord Fieldtrials banner',
  [TranslationKeys.eshop_banner_text]: 'E-SHOP',
  [TranslationKeys.eshop_modal_title]: 'Confirm E-Shop Access',
  [TranslationKeys.eshop_modal_content_prefix]:
    'You are about to enter E-Shop as',
  [TranslationKeys.eshop_modal_content_suffix]: '. Do you want to proceed?',
  [TranslationKeys.eshop_modal_business_partner]: 'Business Partner',
  [TranslationKeys.common_cancel]: 'Cancel',
  [TranslationKeys.common_confirm]: 'Confirm',
  [TranslationKeys.administration_translations]: 'Translations',
  [TranslationKeys.delivery_plan_table_footer]:
    'Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt ut labore et dolore magna aliquyam erat, sed diam voluptua. At vero eos et accusam et justo duo dolores et ea rebum. Stet clita kasd gubergren, no sea takimata sanctus est Lorem ipsum dolor sit amet.',
  [TranslationKeys.administration_statistics_title]:
    'Administration Statistics',
  [TranslationKeys.administration_statistics_get_bp_statistic_button]:
    'Get Buisness Partner statistics',
  [TranslationKeys.administration_statistics_get_user_statistic_button]:
    'Get Users Statistics',
  [TranslationKeys.field_nomination_banner_text]: 'Field nomination',
  [TranslationKeys.my_contracts_e_contracting_button]: 'e-Contracting',
  [TranslationKeys.my_tasks_survey_available]: 'Survey is available',
  [TranslationKeys.my_tasks_fill_survey]: 'Fill out survey',
  [TranslationKeys.survey_redcert_section_title]: 'RedCert',
  [TranslationKeys.hint_input_placeholder]: 'Enter hint text...',
  [TranslationKeys.hint_more_information]: 'Further information',
  [TranslationKeys.daterangepicker_start_time]: 'Start Time',
  [TranslationKeys.daterangepicker_end_time]: 'End Time',
  [TranslationKeys.invekos_number_label]: 'InVeKoS Number',
  [TranslationKeys.invekos_number_error]:
    'Invalid InVeKoS number. Must start with 276 and have 15 digits.',
  [TranslationKeys.survey_form_modal_last_saved_by]: 'Last saved by',
  [TranslationKeys.survey_form_modal_last_saved_on]: 'on',
  [TranslationKeys.survey_form_modal_invekos_number]: 'Invekos Number',
  [TranslationKeys.survey_form_modal_consent_error]:
    'Consent is required to submit',
  [TranslationKeys.survey_form_modal_cancel_button]: 'Cancel',
  [TranslationKeys.survey_form_modal_submit_button]: 'Submit',
  [TranslationKeys.survey_form_modal_required_field]: 'This field is required',
  [TranslationKeys.survey_form_modal_success_message]:
    'Survey submitted successfully!',
  [TranslationKeys.survey_form_modal_close_modal_title]: 'Close Survey',
  [TranslationKeys.survey_form_modal_close_modal_content]:
    'Are you sure you want to close this survey? All unsaved changes will be lost.',
  [TranslationKeys.survey_form_modal_close_modal_confirm]: 'Close',
  [TranslationKeys.confirm_action_modal_cancel_button]: 'Cancel',
  [TranslationKeys.confirm_action_modal_delete_button]: 'Delete',
  [TranslationKeys.survey_form_create_new_survey]: 'Create New Survey',
  [TranslationKeys.survey_form_survey_name]: 'Survey Name',
  [TranslationKeys.survey_form_survey_description]: 'Survey Description',
  [TranslationKeys.survey_form_add_survey_hint]: 'Add survey hint',
  [TranslationKeys.survey_form_survey_hint]: 'Survey Hint',
  [TranslationKeys.survey_form_cancel]: 'Cancel',
  [TranslationKeys.survey_form_create_survey]: 'Create Survey',
  [TranslationKeys.survey_form_saving]: 'Saving...',
  [TranslationKeys.survey_form_survey_title]: 'Survey Title',
  [TranslationKeys.survey_form_edit_title]: 'Edit Title',
  [TranslationKeys.survey_form_save_title]: 'Save Title',
  [TranslationKeys.survey_form_survey_hint_section]: 'Survey Hint',
  [TranslationKeys.survey_form_edit_hint]: 'Edit Hint',
  [TranslationKeys.survey_form_save_hint]: 'Save Hint',
  [TranslationKeys.survey_form_survey_description_section]:
    'Survey Description',
  [TranslationKeys.survey_form_edit_description]: 'Edit Description',
  [TranslationKeys.survey_form_save_description]: 'Save Description',
  [TranslationKeys.survey_form_survey_date_range]: 'Survey Date Range',
  [TranslationKeys.survey_form_edit_dates]: 'Edit Dates',
  [TranslationKeys.survey_form_save_dates]: 'Save Dates',
  [TranslationKeys.survey_form_save_survey]: 'Save Survey',
  [TranslationKeys.survey_list_create_new_survey]: 'Create New Survey',
  [TranslationKeys.survey_list_create_new_survey_disabled_tooltip]:
    'Cannot create new survey while another survey is active',
  [TranslationKeys.survey_list_table_header_name]: 'Name',
  [TranslationKeys.survey_list_table_header_type]: 'Type',
  [TranslationKeys.survey_list_table_header_start_date]: 'Start Date',
  [TranslationKeys.survey_list_table_header_start_time]: 'Start Time',
  [TranslationKeys.survey_list_table_header_end_date]: 'End Date',
  [TranslationKeys.survey_list_table_header_end_time]: 'End Time',
  [TranslationKeys.survey_list_table_header_actions]: 'Actions',
  [TranslationKeys.survey_list_loading]: 'Loading...',
  [TranslationKeys.survey_list_error_loading]: 'Error loading surveys',
  [TranslationKeys.survey_list_no_surveys]: 'No surveys found',
  [TranslationKeys.survey_list_action_edit]: 'Edit',
  [TranslationKeys.survey_list_action_delete]: 'Delete',
  [TranslationKeys.survey_list_delete_modal_title]: 'Delete Survey',
  [TranslationKeys.survey_list_delete_modal_confirm_generic]:
    'Are you sure you want to delete this survey?',
  [TranslationKeys.survey_list_delete_modal_warning]:
    'This action cannot be undone.',
  [TranslationKeys.survey_list_delete_modal_confirm_single]:
    'Are you sure you want to delete survey',
  [TranslationKeys.survey_question_controls_save_question]: 'Save Question',
  [TranslationKeys.survey_question_controls_edit_question]: 'Edit Question',
  [TranslationKeys.survey_question_controls_remove_question]: 'Remove question',
  [TranslationKeys.survey_question_form_question]: 'Question',
  [TranslationKeys.survey_question_form_updating]: 'Updating...',
  [TranslationKeys.survey_question_form_update]: 'Update',
  [TranslationKeys.survey_question_form_deleting]: 'Deleting...',
  [TranslationKeys.survey_question_form_delete]: 'Delete',
  [TranslationKeys.survey_question_form_saved]: 'Saved',
  [TranslationKeys.survey_question_form_edit]: 'Edit',
  [TranslationKeys.survey_question_form_saving]: 'Saving...',
  [TranslationKeys.survey_question_form_save_question]: 'Save Question',
  [TranslationKeys.survey_question_form_question_type]: 'Question Type',
  [TranslationKeys.survey_question_form_answer_type]: 'Answer Type',
  [TranslationKeys.survey_question_form_question_header]: 'Question header',
  [TranslationKeys.survey_question_form_question_header_placeholder]:
    'Enter question header...',
  [TranslationKeys.survey_question_form_question_placeholder]: 'Enter question',
  [TranslationKeys.survey_question_form_prefilled_answer]: 'Prefilled answer',
  [TranslationKeys.survey_question_form_prefilled_answer_placeholder]:
    'Enter prefilled answer...',
  [TranslationKeys.survey_question_form_question_type_standard]: 'Standard',
  [TranslationKeys.survey_question_form_question_type_prefilled]: 'Prefilled',
  [TranslationKeys.survey_question_form_answer_type_single_choice]:
    'Single choice',
  [TranslationKeys.survey_question_form_answer_type_textarea]: 'Text Area',
  [TranslationKeys.survey_question_form_positive_answer]: 'Positive answer',
  [TranslationKeys.survey_question_form_negative_answer]: 'Negative answer',
  [TranslationKeys.survey_question_form_remove_answer_option]:
    'Remove answer option',
  [TranslationKeys.survey_question_form_add_answer_option]: 'Add Answer Option',
  [TranslationKeys.survey_question_form_max_options]: 'Maximum 2 options',
  [TranslationKeys.survey_question_form_add_hint]: 'Add hint',
  [TranslationKeys.survey_question_form_hint_placeholder]: 'Enter hint text...',
  [TranslationKeys.survey_question_form_add_hint_label]: 'Add hint',
  [TranslationKeys.survey_question_type_selector_question_type_label]:
    'Question Type',
  [TranslationKeys.survey_question_type_selector_question_type_standard]:
    'Standard',
  [TranslationKeys.survey_question_type_selector_question_type_prefilled]:
    'Prefilled',
  [TranslationKeys.survey_question_type_selector_answer_type_label]:
    'Answer Type',
  [TranslationKeys.survey_question_type_selector_answer_type_single_choice]:
    'Single choice',
  [TranslationKeys.survey_question_type_selector_answer_type_textarea]:
    'Text Area',
  [TranslationKeys.survey_question_type_selector_cancel]: 'Cancel',
  [TranslationKeys.survey_question_type_selector_add]: 'Add',
  [TranslationKeys.survey_questions_title]: 'Survey Questions:',
  [TranslationKeys.survey_questions_add_question]: 'Add question',
  [TranslationKeys.survey_questions_delete_modal_title]: 'Delete Question',
  [TranslationKeys.survey_questions_delete_modal_content]:
    'Are you sure you want to delete question "{text}"?',
  [TranslationKeys.survey_questions_delete_modal_content_generic]:
    'Are you sure you want to delete this question?',
  [TranslationKeys.survey_questions_delete_modal_content_with_text]:
    'Are you sure you want to delete question',
  [TranslationKeys.administration_tab_delivery_plan]: 'Delivery Plan',
  [TranslationKeys.administration_tab_redcert]: 'RedCert',
  [TranslationKeys.survey_question_form_question_title]: 'Question',
  [TranslationKeys.survey_form_survey_consents_section]: 'Consents',
  [TranslationKeys.survey_form_edit_consents]: 'Edit consents',
  [TranslationKeys.survey_form_save_consents]: 'Save consents',
  [TranslationKeys.survey_form_modal_confirm_cancel_button]: 'Confirm',
  [TranslationKeys.survey_form_hint_for_invekos]: 'Invekos hint',
  [TranslationKeys.survey_form_hint_for_invekos_title]: 'Invekos Hint',
  [TranslationKeys.survey_form_main_consent]:
    'Main consent (field with checkbox for user)',
  [TranslationKeys.survey_form_additional_consent]:
    'Additional consent if needed',
  [TranslationKeys.survey_form_success_message_title]: 'Thank you!',
  [TranslationKeys.survey_form_success_confirm_button]: 'OK',
  [TranslationKeys.survey_form_modal_invekos_header]: 'Invekos number',
  [TranslationKeys.survey_form_modal_incomplete_answers_warning]:
    'Please enter your answers',
  [TranslationKeys.invekos_number_invalid]:
    'Invalid Invekos number. Must start with 270 and have 15 digits.',
  [TranslationKeys.general_document_copy_link]: 'Copy link',
  [TranslationKeys.general_document_move_up]: 'Move up',
  [TranslationKeys.general_document_move_down]: 'Move down',
  [TranslationKeys.general_document_edit]: 'Edit',
  [TranslationKeys.general_document_delete]: 'Delete',
  [TranslationKeys.general_document_loading]: 'Loading...',
  [TranslationKeys.create_general_document_banner_title]:
    'Create General Document Banner',
  [TranslationKeys.create_general_document_banner_headline]: 'Headline',
  [TranslationKeys.create_general_document_banner_text]: 'Text',
  [TranslationKeys.create_general_document_banner_document]: 'Document',
  [TranslationKeys.create_general_document_banner_color]: 'Color',
  [TranslationKeys.create_general_document_list_title]:
    'Create General Document List',
  [TranslationKeys.create_general_document_document_name]: 'Document Name',
  [TranslationKeys.create_general_document_list_subheadline]: 'Subheadline',
  [TranslationKeys.general_document_admin_title]: 'Administration',
  [TranslationKeys.general_document_admin_add_new_document_list_button]:
    'Add new document list',
  [TranslationKeys.general_document_admin_add_new_document_banner_button]:
    'Add new document banner',
  [TranslationKeys.general_document_cancel_button]: 'Cancel',
  [TranslationKeys.general_document_save_button]: 'Save',
  [TranslationKeys.general_document_create_button]: 'Create',
  [TranslationKeys.general_document_remove_document_button]: 'Remove document',
  [TranslationKeys.general_document_add_document_button]: 'Add document',
  [TranslationKeys.general_document_add_subheadline_button]: 'Add subheadline',
  [TranslationKeys.general_document_remove_subheadline_button]:
    'Remove subheadline',
  [TranslationKeys.general_document_delete_warning_title]:
    'You cannot delete general document list if there are still documents in it',
  [TranslationKeys.general_document_ok_button]: 'Ok',
  [TranslationKeys.my_tasks_admin_title]: 'My Tasks Administration',
  [TranslationKeys.my_tasks_admin_select_country_label]: 'Select Country',
  [TranslationKeys.my_tasks_table_header_headline]: 'Headline',
  [TranslationKeys.my_tasks_table_header_type]: 'Type',
  [TranslationKeys.my_tasks_table_header_start_date]: 'Start Date',
  [TranslationKeys.my_tasks_table_header_end_date]: 'End Date',
  [TranslationKeys.my_tasks_table_header_status]: 'Status',
  [TranslationKeys.my_tasks_table_header_action]: 'Action',
  [TranslationKeys.my_tasks_valid]: 'Valid',
  [TranslationKeys.my_tasks_expired]: 'Expired',
  [TranslationKeys.my_tasks_admin_create_button]: 'Create Task',
  [TranslationKeys.my_tasks_admin_action_edit_button]: 'Edit',
  [TranslationKeys.my_tasks_admin_action_delete_button]: 'Delete',
  [TranslationKeys.my_tasks_admin_delete_confirmation]:
    'Are you sure you want to delete this task?',
  [TranslationKeys.my_tasks_widget_title]: 'My Tasks',
  [TranslationKeys.my_tasks_widget_manage_button]: 'Manage',
  [TranslationKeys.my_tasks_create_modal_title]: 'Create Task',
  [TranslationKeys.my_tasks_create_modal_headline]: 'Headline',
  [TranslationKeys.my_tasks_create_modal_description]: 'Description',
  [TranslationKeys.my_tasks_create_modal_task_type]: 'Task Type',
  [TranslationKeys.my_tasks_create_modal_external_url]: 'External URL',
  [TranslationKeys.my_tasks_create_modal_internal_url]: 'Internal URL',
  [TranslationKeys.my_tasks_create_modal_eshop]: 'E-Shop',
  [TranslationKeys.my_tasks_create_modal_econtracting]: 'E-Contracting',
  [TranslationKeys.my_tasks_create_modal_field_map]: 'Field Map',
  [TranslationKeys.my_tasks_create_modal_redcert]: 'RedCert',
  [TranslationKeys.my_tasks_create_modal_general_document]: 'General Document',
  [TranslationKeys.my_tasks_create_modal_survey]: 'Survey',
  [TranslationKeys.my_tasks_create_modal_external_url_input]: 'External URL:',
  [TranslationKeys.my_tasks_create_modal_internal_url_input]: 'Internal URL:',
  [TranslationKeys.my_tasks_create_modal_general_document_input]:
    'Choose Document:',
  [TranslationKeys.my_tasks_create_modal_redcert_input]: 'RedCert Survey Id:',
  [TranslationKeys.my_tasks_create_modal_survey_csv_input]: 'Survey CSV:',
  [TranslationKeys.my_tasks_create_modal_valid_from]: 'Valid from',
  [TranslationKeys.my_tasks_create_modal_valid_from_time]: 'Valid from time',
  [TranslationKeys.my_tasks_create_modal_valid_to]: 'Valid to',
  [TranslationKeys.my_tasks_create_modal_valid_to_time]: 'Valid to time',
  [TranslationKeys.my_tasks_create_modal_assignment_type]: 'Assigned to:',
  [TranslationKeys.my_tasks_create_modal_roles]: 'Roles',
  [TranslationKeys.my_tasks_create_modal_single]: 'Single',
  [TranslationKeys.my_tasks_create_modal_roles_select]: 'Select Roles',
  [TranslationKeys.my_tasks_create_modal_single_input]:
    'Grant Access per BP (one BP number per line):',
  [TranslationKeys.my_tasks_create_modal_cancel]: 'Cancel',
  [TranslationKeys.my_tasks_create_modal_save]: 'Save',
  [TranslationKeys.my_tasks_create_modal_create]: 'Create',
  [TranslationKeys.my_tasks_csv_invalid_warning_message]:
    'Please upload a valid CSV file',
  [TranslationKeys.samplefrequency_widget_title]: 'Sampling frequency',
  [TranslationKeys.samplefrequency_table_header_cell_sample]: 'Sampl. %',
  [TranslationKeys.samplefrequency_table_header_cell_devlivery_category]:
    'Delivery cat.',
  [TranslationKeys.beetprice_widget_title]:
    'Ihre durchschnittlichen Rübenpreise (Netto)',
  [TranslationKeys.beetprice_table_header_cell_year]: 'Jahr',
  [TranslationKeys.beetprice_table_header_cell_price]: 'Gesamtrübenpreis €',
  [TranslationKeys.generaldocuments_picker_back_option]: 'Go back',
  [TranslationKeys.generaldocuments_picker_open_picker_button]:
    'Open General Document Picker',
  [TranslationKeys.generaldocuments_picker_header]: 'Choose General Document',
  [TranslationKeys.generaldocuments_picker_loading_info]: 'Loading...',
  [TranslationKeys.individual_documents_widget_anbauempfehlung_title]:
    'Listing of Anbauempfehlung',
  [TranslationKeys.individual_documents_widget_newsletters_title]:
    'Listing of Newsletters',
  [TranslationKeys.individual_documents_widget_liefermitteilungen_title]:
    'Listing of Liefermitteilungen',
  [TranslationKeys.individual_documents_title]: 'Individual Documents',
  [TranslationKeys.general_document_delete_subheadline_warning]:
    'You cannot delete subheadline if there are still documents in it',
  [TranslationKeys.create_general_document_modal_choose_document]:
    'Please choose a document',
  [TranslationKeys.masterdata_transport_explaination_note]:
    '*Für GMP-Transporte (Futermittel) in Speditionsanfuhr wird ein GMP-Aufschlag von derzeit 0,50 EUR/t erhoben',
  [TranslationKeys.masterdata_headline_title_label]: 'Title',
  [TranslationKeys.masterdata_headline_name_label]: 'Name',
  [TranslationKeys.masterdata_headline_bpNumber_label]: 'BP-number',
  [TranslationKeys.masterdata_headline_office_label]: 'Office',
  [TranslationKeys.masterdata_headline_euFarmNumber_label]: 'euFarmNumber',
  [TranslationKeys.masterdata_headline_personalIdentityCardNumber_label]:
    'Personal identity card (number)',
  [TranslationKeys.masterdata_headline_personalIdentityCardValidFrom_label]:
    'Personal identity card (Valid from)',
  [TranslationKeys.masterdata_headline_socialSecurityNumber_label]:
    'PESEL number / Social security number',
  [TranslationKeys.masterdata_headline_street_label]: 'Street',
  [TranslationKeys.masterdata_headline_houseNo_label]: 'Nr.',
  [TranslationKeys.masterdata_headline_street5_label]: 'Street 5',
  [TranslationKeys.masterdata_headline_postalCode_label]: 'Zip Code',
  [TranslationKeys.masterdata_headline_city_label]: 'City',
  [TranslationKeys.masterdata_headline_district_label]: 'District',
  [TranslationKeys.masterdata_headline_telephone_label]: 'Telephone',
  [TranslationKeys.masterdata_headline_fax_label]: 'Fax',
  [TranslationKeys.masterdata_headline_mail_label]: 'Mail',
  [TranslationKeys.masterdata_headline_bankName_label]: 'Bank name',
  [TranslationKeys.masterdata_headline_bankAccountNr_label]: 'Bank account nr',
  [TranslationKeys.masterdata_headline_bankCode_label]: 'Bank code',
  [TranslationKeys.masterdata_headline_iban_label]: 'IBAN',
  [TranslationKeys.masterdata_headline_taxNumber_label]: 'Tax number',
  [TranslationKeys.masterdata_headline_vatNumber_label]: 'VAT Number',
  [TranslationKeys.masterdata_headline_vatOrRR_label]: 'Tax status information',
  [TranslationKeys.masterdata_headline_bezugspunkt_label]: 'Bezugspunkt',
  [TranslationKeys.masterdata_headline_bzpInKm_label]: 'BZP in km',
  [TranslationKeys.masterdata_headline_frachtsatzUeberrueben_label]:
    'Frachtsatz Überrüben für BZP €/t',
  [TranslationKeys.masterdata_headline_frachtsatzProdukte_label]:
    'Frachtsatz Produkte für BZP €/t',
  [TranslationKeys.masterdata_section_general_label]: 'General',
  [TranslationKeys.masterdata_section_address_label]: 'Address',
  [TranslationKeys.masterdata_section_communication_label]: 'Communication',
  [TranslationKeys.masterdata_section_bankAndVat_label]: 'Bank & VAT',
  [TranslationKeys.masterdata_section_transport_label]: 'Transport',
  [TranslationKeys.individual_documents_widget_inbox_title]: 'My Documents',
  [TranslationKeys.all_individual_documents_list_title]: 'All Documents',
  [TranslationKeys.documents_list_column_header_category_filter_close_button]:
    'Close',
  [TranslationKeys.document_widget_unread_indicator]: 'new',
  [TranslationKeys.individual_documents_main_newsletters_title]: 'Newsletters',
  [TranslationKeys.individual_documents_main_anbauempfehlung_title]:
    'Anbauempfehlung',
  [TranslationKeys.individual_documents_main_liefermitteilungen_title]:
    'Liefermitteilungen',
  [TranslationKeys.noncloseable_welcomemodal_title]: 'Welcome to CropConnect',
  [TranslationKeys.noncloseable_welcomemodal_paragraph_1]:
    'Before reporting your fieldboundaries, please confirm your emails in the old AgriPortal once before using CropConnect.',
  [TranslationKeys.noncloseable_welcomemodal_paragraph_2]:
    'A Confirmation is needed for the following Business numbers:',
  [TranslationKeys.noncloseable_welcomemodal_paragraph_3]:
    'After confirmation of Emails, wait __ minutes and your CropConnect account is ready to go.',
  [TranslationKeys.on_switching_BP_warning_modal_title]: 'Verification needed',
  [TranslationKeys.on_switching_BP_warning_modal_paragraph_1]:
    'Before entering your Business partner number, your email address has to be confirmed in the old AgriPortal.',
  [TranslationKeys.on_switching_BP_warning_modal_paragraph_2]:
    'To do this, log in to your AgriPortal account and verify that the email addresses you entered are correct and that all Emails are allowed to access all data of your BP.',
  [TranslationKeys.on_switching_BP_warning_modal_paragraph_3]:
    'If you are not the owner of this Business partner number, please reach out for the owner, for verification.',
  [TranslationKeys.on_switching_BP_warning_modal_paragraph_4]:
    'After confirming your email addresses, please wait 3 hours for your CropConnect account to be ready.',
  [TranslationKeys.on_switching_BP_warning_modal_paragraph_5]:
    'In case of questions or problems please reach out for your Agricenter.',
  [TranslationKeys.on_switching_BP_warning_modal_close_button]: 'Go back',
  [TranslationKeys.bannerapc_title]: 'Agri Portal Consult',
  [TranslationKeys.bannerapc_subtitle]:
    'Requires log in with Agri Portal password',
  [TranslationKeys.bannerapc_image_alt]: 'Banner APC Image Alt',

  // #region Variety Planner
  [TranslationKeys.variety_planner_form_response_no]: 'No',
  [TranslationKeys.variety_planner_form_response_yes]: 'Yes',
  [TranslationKeys.variety_planner_form_response_neutral]: 'Neutral',
  [TranslationKeys.variety_planner_modal_title]: 'Variety Planner',
  [TranslationKeys.variety_planner_modal_description]: 'Season 2025',
  [TranslationKeys.variety_planner_no_filters_text]:
    'When no filters are applied, suggestions are shown based on sugar yield.',
  [TranslationKeys.variety_planner_filters_applied_text]: 'Filters applied:',
  [TranslationKeys.variety_planner_form_info_text_1]:
    'With the Variety Planner, you can find the right product based on the parameters of your field.',
  [TranslationKeys.variety_planner_form_info_text_2]:
    'All recommendations are backed by Nordzucker expert analysis',
  [TranslationKeys.variety_planner_clear_filters_button_text]: 'Clear filters',
  [TranslationKeys.variety_planner_filters_see_less_btn_text]: 'See less',
  [TranslationKeys.variety_planner_filters_see_more_btn_text]:
    'Select more filters',
  [TranslationKeys.variety_planner_table_section_title]: 'Products',
  [TranslationKeys.variety_planner_table_loading_text]: 'Loading data...',
  [TranslationKeys.variety_planner_table_loading_more_text]: 'Loading more...',
  [TranslationKeys.variety_planner_table_error_loading_data]:
    'Error loading data',
  [TranslationKeys.varietyPlanner_Q_1]:
    'Treten an Ihrem Standort Nematoden auf?',
  [TranslationKeys.varietyPlanner_Q_1_YES_TAG]: 'Ja',
  [TranslationKeys.varietyPlanner_Q_1_NO_TAG]: 'Nein',
  [TranslationKeys.varietyPlanner_Q_2]:
    'Gibt es in Ihrer Umgebung Rizomania Toleranzbruch Verdachtsfälle?',
  [TranslationKeys.varietyPlanner_Q_2_YES_TAG]: 'Ja',
  [TranslationKeys.varietyPlanner_Q_2_NO_TAG]: 'Nein',
  [TranslationKeys.varietyPlanner_Q_3]:
    'Erwarten Sie an Ihrem Standort Cercospora Starkbefall?',
  [TranslationKeys.varietyPlanner_Q_3_YES_TAG]: 'Ja (sehr blattgesund)',
  [TranslationKeys.varietyPlanner_Q_3_NEUTRAL_TAG]: 'Neutral (blattgesund)',
  [TranslationKeys.varietyPlanner_Q_3_NO_TAG]: 'Nein',
  [TranslationKeys.varietyPlanner_Q_4]:
    'Wünschen Sie eine SBR tolerante Sorte?',
  [TranslationKeys.varietyPlanner_Q_4_YES_TAG]: 'Ja',
  [TranslationKeys.varietyPlanner_Q_4_NEUTRAL_TAG]: 'Neutral',
  [TranslationKeys.varietyPlanner_Q_4_NO_TAG]: 'Nein',
  [TranslationKeys.varietyPlanner_Q_5]: 'Conviso Smart System gewünscht?',
  [TranslationKeys.varietyPlanner_Q_5_YES_TAG]: 'Ja',
  [TranslationKeys.varietyPlanner_Q_5_NO_TAG]: 'Nein',
  [TranslationKeys.varietyPlanner_Q_6]: 'Legen Sie wert auf hohe Feldaufgänge?',
  [TranslationKeys.varietyPlanner_Q_6_YES_TAG]: 'Ja',
  [TranslationKeys.varietyPlanner_Q_6_NEUTRAL_TAG]: 'Neutral',
  [TranslationKeys.varietyPlanner_Q_6_NO_TAG]: 'Nein',
  [TranslationKeys.varietyPlanner_Q_7]:
    'Welche Sorteneigenschaften und Toleranzen benötigen Sie zusätzlich?',
  [TranslationKeys.varietyPlanner_Q_7_Q_7_A_R]: 'RHC',
  [TranslationKeys.varietyPlanner_Q_7_Q_7_A_G]: 'Gürtelschorf',
  [TranslationKeys.varietyPlanner_Q_7_Q_7_A_B]: 'BMYVV',
  [TranslationKeys.varietyPlanner_Product_CH_0]: 'Sortenname',
  [TranslationKeys.varietyPlanner_Product_CH_1]: 'Zuckerertrag',
  [TranslationKeys.varietyPlanner_Product_CH_2]: 'Zuckergehalt',
  [TranslationKeys.varietyPlanner_Product_CH_3]: 'Rübenertrag',
  [TranslationKeys.varietyPlanner_Product_CH_4]: 'Feldaufgang (rel.)',
  [TranslationKeys.varietyPlanner_Product_CH_5]: 'Schosseranzahl',
  [TranslationKeys.varietyPlanner_Product_CH_6]: 'Cercospora',
  [TranslationKeys.varietyPlanner_Product_CH_7]: 'Mehltau',
  [TranslationKeys.varietyPlanner_Banner_title]: 'Click here for the',
  [TranslationKeys.varietyPlanner_Banner_subtitle]: 'Variety Planner',
  [TranslationKeys.varietyPlanner_Q_1_Abbreviation]: 'NT',
  [TranslationKeys.varietyPlanner_Q_2_Abbreviation]: 'RZ',
  [TranslationKeys.varietyPlanner_Q_3_Abbreviation]: 'CR',
  [TranslationKeys.varietyPlanner_Q_4_Abbreviation]: 'SBR',
  [TranslationKeys.varietyPlanner_Q_5_Abbreviation]: 'CONVISO',
  [TranslationKeys.varietyPlanner_Q_6_Abbreviation]: 'Feldaufgang',
  [TranslationKeys.varietyPlanner_Q_7_Abbreviation]: 'Eigenschaften',
  [TranslationKeys.varietyPlanner_Q_1_Info]:
    'Zystenbildende Rübenzystennematoden (Heterodera schachtii) verursachen Wurzelverkrüppelungen und führen zu erheblichen Ertrags- und Qualitätsverlusten, besonders bei engen Rübenfruchtfolgen.',
  [TranslationKeys.varietyPlanner_Q_2_Info]:
    'Durch BNYVV verursachte Viruskrankheit, übertragen durch Polymyxa betae. Typisch sind Wurzelbartbildung, verminderter Zuckergehalt und teils massive Ertragsdepression.',
  [TranslationKeys.varietyPlanner_Q_3_Info]:
    'Cercospora beticola ist der wichtigste Blattkrankheitserreger in der Zuckerrübe. Früher Befall und mangelnde Fungizidstrategie führen schnell zu massiven Assimilationsverlusten.',
  [TranslationKeys.varietyPlanner_Q_4_Info]:
    'SBR (Syndrome Basses Richesses). Phytoplasmose-bedingtes Syndrom, übertragen durch Zikaden. Führt zu anhaltenden Blattverfärbungen, reduzierter Zuckerbildung und spürbaren Abrechnungsverlusten.',
  [TranslationKeys.varietyPlanner_Q_5_Info]:
    'System aus ALS-toleranter Sorte (Conviso® Smart) und Herbizid (Conviso® One).',
  [TranslationKeys.varietyPlanner_Q_6_Info]: '',
  [TranslationKeys.varietyPlanner_Q_7_Info]:
    'Gürtelschorf\r\nErreger: Aphanomyces cochlioides. Führt zu eingeschnürten, ringförmigen Nekrosen an der Rübenwurzel. Tritt bevorzugt in trockenen, leichten Böden auf. Sortenwahl ist entscheidend.\r\nRhizoctonia\r\nWurzel- und Herzfäule durch Rhizoctonia solani. Gefördert durch verdichtete, feuchte Böden und enge Mais-Rüben-Fruchtfolgen. Früherkennung und Anbau robuster Sorten sind zentral.                                    Beet mild yellowing virus (BMYV)\r\nBMYV wird durch Blattläuse (v. a. Myzus persicae) übertragen und verursacht Vergilbung der Blattadern. In Jahren mit starkem Blattlausdruck kann es zu deutlich verringertem Zuckergehalt kommen.',
  [TranslationKeys.varietyPlanner_legend_recommended_products]: 'Empfohlen',
  [TranslationKeys.varietyPlanner_legend_neutral_products]: 'Neutral',
  [TranslationKeys.varietyPlanner_legend_not_recommended_products]:
    'Nicht empfohlen',
  [TranslationKeys.variety_planner_footnotes]:
    '** Rizomaniatoleratne Sorten - SV 2022-2024 (Leistung der Sorten mit reduziertem Fungizideinsatz) \n * Nematodentolerante Sorten unter Nematodenbefall und Befallsfreiheit - SVN 2022-2024 (Leistung der Sorten mit Fungizidbehandlung) \n ° Sorten mit speziellen Eigenschaften - SSV 2022-2024 (Leistung der Sorten mit reduziertem Fungizideinsatz) \n  °° Conviso Sorten nach methodischer Untersuchung - MU 2023-2024 (Leistung der Sorten mit Fungizid- und klassischem Herbizideinsatz)',

  //#endregion Variety Planner
  [TranslationKeys.general_document_admin_add_new_upload_banner_button]:
    'Add new upload banner',
  [TranslationKeys.create_upload_banner_title]: 'Create Upload Banner',
  [TranslationKeys.create_upload_banner_headline]: 'Headline',
  [TranslationKeys.create_upload_banner_text]: 'Text',
  [TranslationKeys.create_upload_banner_document_type]: 'Document Type',
  [TranslationKeys.upload_document_banner_title]: 'Document upload',
  [TranslationKeys.upload_document_banner_document_type]: 'Document type',
  [TranslationKeys.upload_document_banner_modal_cancel_button]: 'Close',
  [TranslationKeys.upload_document_banner_modal_upload_button]: 'Upload',
  [TranslationKeys.upload_banner_closing_confirmation_title]: 'Cancel Upload?',
  [TranslationKeys.upload_banner_closing_confirmation_question]:
    'Are you sure you want to close this window?',
  [TranslationKeys.upload_banner_closing_confirmation_information]:
    'Your document upload will be closed and any entered information will be cancelled and all progress lost.',
  [TranslationKeys.upload_banner_closing_confirmation_cancel_button]:
    'Cancel upload',
  [TranslationKeys.upload_banner_closing_confirmation_continue_button]:
    'Keep editing',
  [TranslationKeys.upload_document_banner_confirmation_checkbox_text]:
    'I confirm that the files provided are accurate, up-to-date, and legally valid for the intended purpose.',
  [TranslationKeys.file_upload_component_upload_text]:
    'Click and then choose a document file to upload (.pdf, .png, or .jpg). Maximum file size: 20 MB.',
  [TranslationKeys.upload_document_banner_success_message_headline]:
    'Thank you! Your document was uploaded successfully.',
  [TranslationKeys.upload_document_banner_success_message_subheadline_1]:
    "We've received your submission and will begin processing it shortly.",
  [TranslationKeys.upload_document_banner_success_message_subheadline_2]:
    'You may now close this window.',
  [TranslationKeys.upload_document_banner_error_message_headline]:
    'There was an issue with your upload',
  [TranslationKeys.upload_document_banner_error_message_subheadline_1]:
    'Please try to upload your document again.',
  [TranslationKeys.upload_document_banner_error_message_subheadline_2]:
    'If the issue persists, please contact your AgriCenter.',
  [TranslationKeys.upload_document_banner_modal_start_again_button]:
    'Start Again',
  [TranslationKeys.file_upload_component_wrong_type_message]:
    'Only PDF, PNG, and JPG files are allowed.',
  [TranslationKeys.file_upload_component_wrong_size_message]:
    'The file size exceeds the maximum limit of 20 MB. Please choose a smaller file.',
  [TranslationKeys.file_upload_component_selected_file]: 'Selected file',
  [TranslationKeys.upload_document_admin_title]:
    'Upload Document Administration',
  [TranslationKeys.alert_confirm_button_text]: 'OK',
};
